// GENEROWANE z opisu linii w workerze Go: `worker tool typy` (worker-go/tools/typy).
// Nie edytować ręcznie - zmiana kontraktu = zmiana opisu w Go i ponowne wygenerowanie (KN-2).

export interface ViewPresence {
  status: StatusObecnosci;
  since?: number;
  last_live?: number;
  via?: string;
}

export interface ViewPowerLoss {
  dur_s: number | null;
  phase: string;
  core_before: number | null;
  core_after: number | null;
  risk_min: number | null;
  blocked: boolean;
}

export interface ViewRun {
  name: string;
  started: number;
  phase?: string;
  phase_at?: number | null;
  suspended?: boolean;
  power_loss?: ViewPowerLoss | null;
}

export interface EnergyLive {
  startedAt: number | null;
  endedAt: number | null;
  kwh: number;
  meter: number | null;
  peakKw: number;
  cost: number | null;
  tariff?: string;
  unpricedKwh?: number;
  zones?: Record<string, number>;
  heaterSec?: number | null;
}

export interface ViewChartValue {
  idx: number;
  v: number;
}

export interface ViewChart {
  t: number;
  krok: number;
  v: Array<ViewChartValue>;
}

export interface ViewDoc {
  type: TypLinii;
  presence: ViewPresence;
  fw?: string;
  state?: string;
  run?: ViewRun | null;
  energy?: EnergyLive | null;
  fields: Record<string, unknown>;
  settings?: Record<string, unknown>;
  no_sensor?: Array<string>;
  odczyt?: number;
  wykres?: ViewChart | null;
}

export interface DeviceOut {
  sn: string;
  nazwa?: string;
  typ: TypLinii;
  rola: Rola;
  mozna: Array<Poziom>;
  widok: ViewDoc | null;
  klient?: string;
  ostatni_przebieg?: number;
}

export interface DevicesReply {
  ok: boolean;
  urzadzenia: Array<DeviceOut>;
}

export interface DeviceReply {
  ok: boolean;
  urzadzenie: DeviceOut;
}

export interface FieldResult {
  nazwa: string;
  status: StatusKomendy;
  komunikat?: string;
  wartosc?: number | string;
}

export interface CmdResult {
  id: string;
  user: number;
  nazwa: string;
  status: StatusKomendy;
  komunikat?: string;
  wartosc?: number | string;
  pola?: Array<FieldResult>;
}

export interface CommandReply {
  ok: boolean;
  id?: string;
  status?: "w_toku";
  wynik?: CmdResult | null;
}

export interface SamplesChannel {
  idx: number;
  nazwa: string;
}

export interface SamplesMark {
  t: number;
  nazwa: string;
  rodzaj: "faza" | "brak_czujnika" | "alarm";
  do?: number;
  kanal?: number | null;
}

export interface SamplesReply {
  ok: boolean;
  krok: number;
  kanaly: Array<SamplesChannel>;
  t: Array<number>;
  v: Array<Array<number | null>>;
  znaczniki: Array<SamplesMark>;
}

export interface RunsColumn {
  nazwa: string;
  jednostka: string;
  miejsca: number;
}

export interface RunEnergy {
  kwh: number;
  koszt: number | null;
  taryfa: string | null;
  grzalka_s: number;
  udzial_proc: number;
  bez_mocy: boolean;
}

export interface RunOut {
  id: number;
  program: string;
  start: number;
  koniec: number | null;
  status: StatusPrzebiegu;
  faza?: string;
  czas: number;
  wartosci: Array<number | null>;
  energia?: RunEnergy | null;
  ma_zdjecie: boolean;
  zdjecie_ai: boolean;
  ocena_ai: number | null;
  proba: boolean;
  galeria: StanGalerii;
}

export interface RunsReply {
  ok: boolean;
  zapisuje: boolean;
  kolumny: Array<RunsColumn>;
  programy: Array<string>;
  przebiegi: Array<RunOut>;
  wiecej: boolean;
  liczba_prob: number;
}

export interface RunPhaseOut {
  nazwa: string;
  start: number;
  czas: number;
}

export interface RunReply {
  ok: boolean;
  kolumny: Array<RunsColumn>;
  przebieg: RunOut;
  fazy: Array<RunPhaseOut>;
  galeria_dostepna: boolean;
}

export interface RunTrialIn {
  proba: boolean;
}

export interface RunGalleryIn {
  zgoda: boolean;
}

export interface RunGalleryReply {
  ok: boolean;
  galeria: StanGalerii;
}

export interface HardwareReply {
  ok: boolean;
  wartosc: number | string | null;
}

export interface HardwareValues {
  wartosci: Record<string, number | string | null>;
  zapytaj: boolean;
}

export interface ModuleOut {
  sn: string;
  typ: string;
  zgoda: boolean;
  sparowany: boolean;
  lacznosc: boolean | null;
  rssi: number | null;
}

export interface ModulesReply {
  ok: boolean;
  moduly: Array<ModuleOut>;
}

export interface ErrorReply {
  ok: boolean;
  error: KodBledu;
  komunikat?: string;
}

export interface ListEvent {
  urzadzenia: Array<DeviceOut>;
}

export interface ViewEvent {
  sn: string;
  widok: ViewDoc;
}

export interface StreamEvent {
  sn: string;
  rodzaj: keyof DaneZdarzen;
  ts: number;
  dane: unknown;
}

export interface AlarmChanged {
  alarm_id: string;
  alarm_name: string;
  value: number;
  severity: string;
  temperature?: number | null;
  digits?: number;
  event_id: string;
  occurred_ts: number;
  run_end?: boolean;
}

export interface RunOpened {
  key: string;
  name: string;
  started_ts: number;
}

export interface Counter {
  start?: number | null;
  end?: number | null;
}

export interface Gauge {
  min: number;
  max: number;
  sum: number;
  n: number;
}

export interface PhaseClock {
  ts: number;
  v: number | null;
}

export interface RunAction {
  kind: string;
  at: number;
  phase?: string;
  from?: number;
  to?: number;
  code?: string;
  action?: string;
  accepted?: boolean;
}

export interface PowerLoss {
  type: string;
  at: string;
  resumed: boolean | null;
  durSec: number | null;
  coreBefore: number | null;
  coreAfter: number | null;
  riskMin: number | null;
  atSec: number | null;
  cause?: string;
}

export interface ParamChange {
  param: string;
  from: number;
  to: number;
  atElapsedSec: number;
}

export interface ServiceState {
  progress: number;
  abort?: string;
  result?: string;
  switches: number;
  rises: number;
  first_rise?: string;
  last_rise?: string;
  on_ms: number;
  edge?: number | null;
  edge_at?: string;
}

export interface RunClosed {
  key: string;
  name: string;
  started_ts: number;
  ended_ts: number;
  status: string;
  reason: string;
  counters?: Record<string, Counter>;
  fw?: string;
  gauges?: Record<string, Gauge>;
  texts?: Record<string, string>;
  clock?: Array<PhaseClock>;
  actions?: Array<RunAction>;
  power_loss?: Array<PowerLoss>;
  params?: Record<string, number>;
  changes?: Array<ParamChange>;
  service?: ServiceState | null;
  alarms?: number;
}

export interface OfferPlus {
  count: number;
  bonus: number;
  skipBonus: number;
}

export interface OfferRisk {
  min: number | null;
  warn: number;
  coreBefore: number | null;
  coreAfter: number | null;
}

export interface ResumeOffer {
  op: string;
  run?: number;
  prog: string;
  phase: number;
  phaseElapsed: number;
  elapsed: number;
  total: number;
  gapSec: number;
  plus30: OfferPlus;
  risk: OfferRisk;
  recipe?: unknown;
}

export interface RunSuspended {
  key: string;
  name: string;
  started_ts: number;
  power_loss: Array<PowerLoss>;
  offer?: ResumeOffer | null;
}

export interface Account {
  id: number;
  email: string;
  login: string;
  nazwa: string;
  is_admin: boolean;
  is_active: boolean;
  jezyk: JezykAPP | "";
}

export interface AccountReply {
  ok: boolean;
  konto: Account;
  zeton?: string;
}

export interface GoogleIDReply {
  ok: boolean;
  client_id: string;
}

export interface SessionOut {
  id: string;
  przegladarka: string;
  system: string;
  utworzona: number;
  uzyta: number;
  zapamietaj: boolean;
  biezaca: boolean;
}

export interface SessionsReply {
  ok: boolean;
  sesje: Array<SessionOut>;
}

export interface OKReply {
  ok: boolean;
}

export interface Dashboard {
  id: number;
  nazwa: string;
  kolejnosc: number;
  uklady: Partial<Record<RodzajEkranu, Array<Card>>>;
  wersja: number;
}

export interface ClientDashboards {
  nazwa: string;
  pulpity: Array<Dashboard>;
}

export interface DashboardsReply {
  ok: boolean;
  pulpity: Array<Dashboard>;
  klienci: Array<ClientDashboards>;
}

export interface DashboardReply {
  ok: boolean;
  pulpit: Dashboard;
}

export interface VersionReply {
  ok: boolean;
  wersja: number;
}

export interface DeviceLayout {
  uklady: Partial<Record<RodzajEkranu, Array<Card>>>;
  ukryte: Array<string>;
  wersja: number;
}

export interface DeviceLayoutReply {
  ok: boolean;
  uklad: DeviceLayout;
}

export interface TanksReply {
  ok: boolean;
  naczynia: Array<number>;
}

export interface TankIn {
  litry: number;
}

export interface Tile {
  id: string;
  w: number;
}

export interface Card {
  sn: string;
  karta: RodzajKarty;
  x: number;
  y: number;
  w: number;
  h: number;
  ukryte?: Array<string>;
  kafle?: Array<Tile>;
}

export interface AccountEvent {
  rodzaj: keyof DaneKonta;
  ts: number;
  dane: unknown;
}

export interface Rule {
  strefa: string;
  dni?: string;
  sezon?: string;
  od: string;
  do: string;
}

export interface Tariff {
  id: number;
  od: string;
  taryfa: string;
  operator: string;
  czas_zimowy: boolean;
  strefy: Array<Rule>;
  ceny: Record<string, number>;
}

export interface TariffOut {
  dane: Tariff;
  uzyta: boolean;
}

export interface Template {
  operator: string;
  taryfa: string;
  strefy: Array<Rule>;
  zrodlo: string;
}

export interface TariffsReply {
  ok: boolean;
  taryfy: Array<TariffOut>;
  szablony: Array<Template>;
  strefy: Record<string, Array<string>>;
  operatorzy: Array<string>;
}

export interface TariffSaved {
  ok: boolean;
  id: number;
}

export interface EnergySummary {
  dni: number;
  kwh: number;
  koszt: number;
  bez_taryfy_kwh: number;
  sesji: number;
}

export interface EnergySession {
  id: number;
  sn: string;
  nazwa: string;
  start: number;
  koniec: number;
  kwh: number;
  koszt: number | null;
  bez_taryfy_kwh: number;
  strefy: Record<string, number>;
  taryfa: string | null;
  trwa: boolean;
  szacunek: boolean;
  bez_mocy: boolean;
}

export interface EnergyReply {
  ok: boolean;
  podsumowania: Array<EnergySummary>;
  sesje: Array<EnergySession>;
}

export interface Channels {
  telefon: Tryb;
  email: boolean;
}

export interface Night {
  wlaczona: boolean;
  od: number;
  do: number;
}

export interface AlarmPref {
  tryb: Tryb;
}

export interface Prefs {
  kategorie: Record<Kategoria, Channels>;
  cisza: Night;
  email: string;
  alarmy: Record<string, AlarmPref>;
}

export interface PhoneOut {
  id: number;
  przegladarka: string;
  system: string;
  dodany: number;
  wyslano: number | null;
  doreczono: number | null;
}

export interface AlarmKindOut {
  id: string;
  nazwa: string;
  waznosc?: Waznosc;
}

export interface AlarmDeviceOut {
  sztuka: number;
  sn: string;
  nazwa: string;
  typ: TypLinii;
  alarmy: Array<AlarmKindOut>;
}

export interface NotifyReply {
  ok: boolean;
  ustawienia: Prefs;
  klucz: string;
  email_konta: string;
  telefony: Array<PhoneOut>;
  push: boolean;
  aplikacja: boolean;
  email: boolean;
  urzadzenia: Array<AlarmDeviceOut>;
}

export interface NotifyTestIn {
  telefon: number;
}

export interface NotifyTestReply {
  ok: boolean;
  push: boolean;
  email: boolean;
}

export interface AccountDeleteIn {
  email: string;
}

export interface AlarmOut {
  id: number;
  sn: string;
  sztuka: number;
  nazwa_sztuki: string;
  typ: TypLinii;
  nazwa: string;
  alarm_id: string;
  aktywny: boolean;
  temperatura: number | null;
  miejsca: number;
  waznosc: Waznosc;
  status: StatusAlarmu;
  kiedy: number;
  zamkniety: number | null;
}

export interface AlarmCounts {
  nieprzeczytane: number;
  przeczytane: number;
  krytyczne: number;
  ostrzezenia: number;
  informacje: number;
  zamkniete: number;
  wszystkie: number;
}

export interface AlarmsReply {
  ok: boolean;
  alarmy: Array<AlarmOut>;
  liczniki: AlarmCounts;
  rodzaje: Array<AlarmKindOut>;
  wiecej: boolean;
}

export interface AlarmReadReply {
  ok: boolean;
  alarmy: Array<number>;
}

export interface AlarmUnreadIn {
  alarmy: Array<number>;
}

export interface AlarmMuteIn {
  tryb: Tryb | "";
}

export interface ConsentOut {
  klucz: string;
  nazwa: string;
  opis: string;
  domyslnie: boolean;
  wlaczona: boolean;
  na_karcie: boolean;
}

export interface ConsentsReply {
  ok: boolean;
  zgody: Array<ConsentOut>;
}

export interface DeviceNameIn {
  nazwa: string;
}

export interface RecipeCostOut {
  sn: string;
  nazwa: string;
  typ: TypLinii;
  kwh: number;
  koszt: number | null;
  najwyzej: boolean;
  wedzen: number;
}

export interface RecipeCostReply {
  ok: boolean;
  czas_s: number;
  co_najmniej: boolean;
  wedzarnie: Array<RecipeCostOut>;
}

export interface DashboardsChanged {
  user: number;
  id: number;
  wersja: number;
  sn?: string;
}

export interface ShareOut {
  id: number;
  email: string;
  uprawnienie: Uprawnienie;
  stan: StanZaproszenia;
  do: number | null;
  zaproszenie_do: number;
  mozna_odwolac: boolean;
}

export interface SharesReply {
  ok: boolean;
  urzadzenie: string;
  udostepnienia: Array<ShareOut>;
}

export interface InviteReply {
  ok: boolean;
  zmieniono: boolean;
}

export interface InvitationOut {
  id: number;
  urzadzenie: string;
  od: string;
  uprawnienie: Uprawnienie;
  do: number | null;
  wazne_do: number;
}

export interface InvitationsReply {
  ok: boolean;
  zaproszenia: Array<InvitationOut>;
}

export interface AcceptReply {
  ok: boolean;
  sn: string;
}

export interface AccountChanged {
  user: number;
}

export interface GrantOut {
  id: number;
  firma?: string;
  osoba: string;
  stan: StanSerwisu;
  zakonczyl?: KtoZakonczyl;
  powod: string;
  czas: CzasSerwisu;
  urzadzenia: Array<string>;
  od: number;
  prosba_do: number;
  zgoda: number | null;
  do: number | null;
  koniec: number | null;
}

export interface ScreenOut {
  id: number;
  kto: "admin" | "serwis";
  ogladam: boolean;
  firma?: string;
  osoba: string;
  stan: StanEkranu;
  od: number;
  prosba_do: number;
  zgoda: number | null;
  do: number | null;
  koniec: number | null;
}

export interface ServiceReply {
  ok: boolean;
  serwisant: boolean;
  admin: boolean;
  klienci: Array<GrantOut>;
  dostepy: Array<GrantOut>;
  ekrany: Array<ScreenOut>;
}

export interface ServiceRequestIn {
  klient: string;
  powod: string;
  czas: CzasSerwisu;
}

export interface ServiceTesterOut {
  sn: string;
  opis: string;
  moj: boolean;
  wifi: boolean;
  odwolany: boolean;
}

export interface Setting {
  idx: number;
  val: number;
}

export interface ServiceTesterProfileOut {
  id: number;
  nazwa: string;
  wartosci: Array<Setting>;
  zmiana: number;
}

export interface TesterSettingOut {
  idx: number;
  nazwa: string;
  rodzaj: "liczba" | "wl_wyl" | "lista";
  min?: number | null;
  max?: number | null;
  wartosci?: Array<number>;
}

export interface ServiceWifiOut {
  id: number;
  tester_sn: string;
  sterownik: string;
  ssid: string;
  kto: string;
  kiedy: number;
}

export interface ServiceTesterReply {
  ok: boolean;
  testery: Array<ServiceTesterOut>;
  profile: Array<ServiceTesterProfileOut>;
  fabryczny: string;
  nastawy: Array<TesterSettingOut>;
  limit: number;
  nazwa_max: number;
  wifi: Array<ServiceWifiOut>;
}

export interface ServiceTesterProfileIn {
  id: number;
  nazwa: string;
  wartosci: Array<Setting>;
}

export interface ServiceWifiIn {
  ssid: string;
  haslo: string;
  sterownik: string;
}

export interface ScreenRequestIn {
  klient: string;
}

export interface ClientLookupReply {
  ok: boolean;
  nazwa: string;
  email: string;
  sztuki: Array<string>;
}

export interface PendingOut {
  sn: string;
  nazwa: string;
  ident_hash: string;
  od: number;
  ostatnio: number;
  zaakceptowane: boolean;
}

export interface PendingReply {
  ok: boolean;
  oczekujace: Array<PendingOut>;
}

export interface SNStateReply {
  ok: boolean;
  stan: string;
}

export interface ClaimReply {
  ok: boolean;
  nowe: boolean;
}

export interface DeviceRequestOut {
  id: number;
  sn: string;
  rodzaj: RodzajWniosku;
  stan: StanWniosku;
  od: number;
  rozpatrzony: number | null;
  powod: string;
  konto?: number;
  nazwa_konta?: string;
  wlasciciel_numeru?: number | null;
}

export interface DeviceRequestsReply {
  ok: boolean;
  wnioski: Array<DeviceRequestOut>;
  dalej: boolean;
}

export interface DeviceRequestReply {
  ok: boolean;
  juz_moje: boolean;
  wniosek: DeviceRequestOut;
}

export interface RecipeAccess {
  aktywny: boolean;
  darmowy: boolean;
  wkrotce: boolean;
  do: number | null;
  dni: number;
  sklep: string;
}

export interface RecipeCategoryOut {
  id: number;
  nazwa: string;
  wlasna: boolean;
  liczba: number;
}

export interface RecipesReply {
  ok: boolean;
  dostep: RecipeAccess;
  kategorie: Array<RecipeCategoryOut>;
  bez_kategorii: number;
  wszystkie: number;
  sekcje: Record<RodzajPrzepisow, RecipeSectionOut>;
}

export interface RecipePhaseOut {
  rodzaj: string;
  nazwa: string;
  czas_s: number | null;
  temp: number | null;
}

export interface RecipeOut {
  id: number;
  biblioteka: boolean;
  nazwa: string;
  kategoria: string;
  propozycja_ai: boolean;
  notka_ai: string;
  od: string;
  ulubiony: boolean;
  fazy: Array<RecipePhaseOut>;
  wsad_max: number | null;
  parzenie: number | null;
  zdjecia: number;
  czas_s: number | null;
  temp_od: number | null;
  temp_do: number | null;
  moc: number | null;
}

export interface RecipeSectionOut {
  przepisy: Array<RecipeOut>;
  wszystkie: number;
}

export interface RecipeSectionReply {
  ok: boolean;
  sekcja: RecipeSectionOut;
}

export interface RecipePhaseDef {
  rodzaj: string;
  nazwa: string;
  czas: string;
  temp: string;
}

export interface RecipeStageIO {
  nazwa: string;
  dni: number;
  potem: string;
}

export interface RecipeStageTemplateOut {
  rodzaj: string;
  nazwa: string;
  etapy: Array<RecipeStageIO>;
}

export interface RecipeAgingPlaceOut {
  id: string;
  nazwa: string;
  wskazowka: string;
}

export interface RecipeIngredientIO {
  kategoria: KategoriaSkladnika;
  nazwa: string;
  ilosc: number | null;
  jednostka: JednostkaSkladnika;
}

export interface Cure {
  metoda: MetodaPeklowania;
  dni_od: number | null;
  dni_do: number | null;
  wariant: WariantPeklowania | "";
  intensywnosc: IntensywnoscPeklowania | "";
  mieso: MiesoPeklowania | "";
  peklosol_g_kg: number | null;
  procent: number | null;
  woda_l_kg: number | null;
  nastrzyk: string;
  uwagi: string;
  obracanie_dni: number | null;
}

export interface RecipeSectionIO {
  tytul: string;
  kroki: Array<string>;
}

export interface RecipeBrewIO {
  wlaczone: boolean;
  temp_wody_min: number | null;
  temp_wody_max: number | null;
  temp_wewnetrzna: number | null;
  uwagi: string;
}

export interface RecipePhotoIO {
  nr?: number | null;
  dane?: string;
}

export interface RecipeFormIO {
  dziedzina: DziedzinaPrzepisu | "";
  etapy: Array<RecipeStageIO>;
  nazwa: string;
  opis: string;
  kategoria: number | null;
  na_kg: number;
  skladniki: Array<RecipeIngredientIO>;
  peklowanie: Cure | null;
  cel_ubytku: number | null;
  trwalosc_dni: number | null;
  wyrob: KategoriaWyrobu | "";
  przygotowanie: Array<RecipeSectionIO>;
  program: Record<string, number>;
  parzenie: RecipeBrewIO | null;
  dojrzewanie_gdzie: string;
  zdjecia: Array<RecipePhotoIO>;
  szkic: boolean;
  platny: boolean;
  kolejnosc: number;
}

export interface RecipeFormReply {
  ok: boolean;
  dziedzina: DziedzinaPrzepisu;
  fazy: Array<RecipePhaseDef>;
  szablony: Array<RecipeStageTemplateOut>;
  max: string;
  kategorie: Array<RecipeCategoryOut>;
  katalog: Record<KategoriaSkladnika, string[]>;
  miejsca_dojrzewania: Array<RecipeAgingPlaceOut>;
  przepis: RecipeFormIO | null;
  biblioteka: boolean;
  szkic_id: number;
  ulubiony: boolean;
}

export interface RecipeSavedReply {
  ok: boolean;
  id: number;
}

export interface RecipeAmountOut {
  grupa: string;
  nazwa: string;
  ilosc: string;
  na_kg: number | null;
  jednostka: string;
  staly: boolean;
}

export interface RecipeAmountsReply {
  ok: boolean;
  kg: number;
  skladniki: Array<RecipeAmountOut>;
}

export interface RecipeCureSuggestIn {
  peklowanie: Cure;
  kg: number;
}

export interface RecipeCureSuggestReply {
  ok: boolean;
  podpowiedz: Cure;
}

export interface ShopItem {
  grupa: string;
  nazwa: string;
  ilosc: string;
  kupione: boolean;
  wlasna: boolean;
}

export interface StepItem {
  tytul: string;
  tekst: string;
  zrobione: boolean;
}

export interface PlanStageOut {
  etap: string;
  tytul: string;
  kiedy: number;
  kroki: Array<number>;
  zakupy: boolean;
  zrobione: boolean;
  odlozone: number | null;
}

export interface PlanRunOut {
  id: number;
  program: string;
  start: number;
  koniec: number | null;
  status: StatusPrzebiegu;
}

export interface PlanOut {
  id: number;
  sn: string;
  urzadzenie: string;
  trunek: boolean;
  przepis_id: number | null;
  przepis: string;
  ma_zdjecie: boolean;
  przepis_wlasny: boolean;
  data: string;
  godzina: string;
  start: number | null;
  dni: number;
  kg: number;
  zakupy: Array<ShopItem>;
  kroki: Array<StepItem>;
  harmonogram: Array<PlanStageOut>;
  przebieg: PlanRunOut | null;
  kandydaci: Array<PlanRunOut>;
  podpowiedz: string;
  wersja: number;
  moze_zmieniac: boolean;
}

export interface PlanDeviceOut {
  sn: string;
  nazwa: string;
}

export interface PlansReply {
  ok: boolean;
  plany: Array<PlanOut>;
  wedzarnie: Array<PlanDeviceOut>;
}

export interface PlanReply {
  ok: boolean;
  plan: PlanOut;
}

export interface PlanCreateIn {
  przepis: number;
  sn: string;
  data: string;
  godzina: string;
  kg: number;
}

export interface PlanSaveIn {
  wersja: number;
  data: string;
  godzina: string;
  kg: number;
  zakupy: Array<ShopItem>;
  kroki: Array<StepItem>;
}

export interface PlanRunIn {
  wersja: number;
  przebieg: number;
}

export interface PlanChanged {
  user: number;
  id: number;
  wersja: number;
}

export interface Weighing {
  at: number;
  kg: number;
}

export interface AfterReply {
  ok: boolean;
  program: string;
  koniec: number | null;
  masa_start: number | null;
  masa_zrodlo: string;
  cel_ubytku: number | null;
  trwalosc_dni: number | null;
  wazenia: Array<Weighing>;
  ubytek: number | null;
  gotowe: boolean;
  gotowe_za_dni: number | null;
  spozyc_do: number | null;
}

export interface AfterIn {
  masa_start: number | null;
  cel_ubytku: number | null;
  trwalosc_dni: number | null;
  wazenie: number | null;
  usun_wazenie: number | null;
}

export interface AnalysisGrades {
  kolor: number;
  rownomiernosc: number;
  wyglad: number;
}

export interface AnalysisCard {
  werdykt: string;
  wyrob: KategoriaWyrobu;
  oceny: AnalysisGrades | null;
  jakoscZdjecia: "ok" | "nieostre" | "ciemne" | "nie_ten_wyrob" | "brak";
  pewnosc: number;
  wyszloDobrze: Array<string>;
  naNastepnyRaz: Array<string>;
  komentarz: string;
  bezpieczenstwo: string;
  problemy: Array<string>;
  propozycja: "lepiej" | "tak_samo" | "gorzej" | "";
  pytania: Array<string>;
  awaryjna: boolean;
}

export interface AnalysisReply {
  ok: boolean;
  stan: "brak" | "czeka_na_zdjecie" | "w_toku" | "gotowa";
  termin: number | null;
  zdjecie: boolean;
  karta: AnalysisCard | null;
  tekst: string;
  ocena: boolean | null;
  styl: string;
  postepy: Array<string>;
}

export interface AnalysisRateIn {
  pomocna: boolean;
  komentarz: string;
}

export interface RunPhotoIn {
  zdjecie: string;
}

export interface LoadCheck {
  najwazniejsze: string;
  punkty: Array<string>;
}

export interface LoadReply {
  ok: boolean;
  zapisany: boolean;
  przebieg: number;
  program: string;
  trwa: boolean;
  pytajCo: boolean;
  wyroby: Array<KategoriaWyrobu>;
  kg: number | null;
  szt: number | null;
  zdjecie: boolean;
  ocena: LoadCheck | null;
}

export interface LoadIn {
  zdjecie: string;
  kg: number | null;
  szt: number | null;
  wyroby: Array<KategoriaWyrobu>;
}

export interface Film {
  tytul: string;
  url: string;
  video_id: string;
  miniatura: string;
}

export interface ChatQuestion {
  id: number;
  pytanie: string;
  stan: "czeka" | "gotowa" | "odrzucona";
  odpowiedz: string;
  czesc: string;
  powod: string;
  z_bazy: boolean;
  wpis: number;
  watek: number;
  cykle: Array<number>;
  ocena: number;
  zadane: number;
  film: Film | null;
}

export interface ChatWindow {
  limit: number;
  zostalo: number;
  reset_s: number;
}

export interface ChatLimit {
  h: ChatWindow;
  d: ChatWindow;
}

export interface ChatEntry {
  id: number;
  pytanie: string;
  odpowiedz: string;
  kat: string;
  zrodlo: string;
  url: string;
  tagi: Array<string>;
  pop: number;
}

export interface ChatTopic {
  nazwa: string;
  wpisy: number;
}

export interface ChatFilm {
  temat: string;
  tytul: string;
  url: string;
  video_id: string;
  miniatura: string;
}

export interface ChatCycle {
  id: number;
  urzadzenie: string;
  sn: string;
  program: string;
  wyrob: string;
  trwa: boolean;
  start: number;
  koniec: number | null;
  temp: number | null;
  domyslny: boolean;
}

export interface ChatReply {
  ok: boolean;
  imie: string;
  pytania: Array<ChatQuestion>;
  limit: ChatLimit;
  przyklady: Array<ChatEntry>;
  tematy: Array<ChatTopic>;
  filmy: Array<ChatFilm>;
  przebiegi: Array<ChatCycle>;
}

export interface ChatIn {
  pytanie: string;
  cykle: Array<number>;
  do: number;
  temat: string;
  wiecej: boolean;
}

export interface ChatSent {
  ok: boolean;
  pytanie: ChatQuestion;
  limit: ChatLimit;
}

export interface ChatLimitReply {
  ok: boolean;
  error: string;
  powod: string;
  limit: ChatLimit;
}

export interface ChatRateIn {
  dobra: boolean;
}

export interface ChatSearchReply {
  ok: boolean;
  wpisy: Array<ChatEntry>;
}

export interface ChatBaseReply {
  ok: boolean;
  v: number;
  bez_zmian: boolean;
  wpisy: Array<ChatEntry>;
}

export interface TabletGraphic {
  klucz: string;
  wlasne: boolean;
}

export interface TabletGraphicsReply {
  ok: boolean;
  w: number;
  h: number;
  grafiki: Array<TabletGraphic>;
}

export interface TabletPhotoOut {
  klucz: string;
  kategoria: string;
  sn: string;
  bajty: number;
  szer: number;
  wys: number;
  dodano: number;
}

export interface TabletPhotosReply {
  ok: boolean;
  max: number;
  max_bajty: number;
  kategorie: Array<string>;
  zdjecia: Array<TabletPhotoOut>;
}

export interface TabletPhotoIn {
  kategoria: string;
  sn: string;
  obraz: string;
}

export interface TabletPhotoReply {
  ok: boolean;
  zdjecie: TabletPhotoOut;
}

export interface TabletSoundOut {
  klucz: string;
  nazwa: string;
  hz: number;
  bajty: number;
  sha256: string;
  dodano: number;
}

export interface TabletSoundsReply {
  ok: boolean;
  max: number;
  max_bajty: number;
  czestotliwosci: Array<number>;
  dzwieki: Array<TabletSoundOut>;
}

export interface TabletSoundIn {
  nazwa: string;
  wav: string;
}

export interface TabletSoundReply {
  ok: boolean;
  dzwiek: TabletSoundOut;
}

export interface ChatLive {
  user: number;
  id: number;
  stan: "czeka" | "gotowa" | "odrzucona";
  tekst: string;
}

export interface ChatCyclesReply {
  ok: boolean;
  cykle: Array<ChatCycle>;
}

export interface HelpOption {
  t: string;
  do: string;
}

export interface HelpNode {
  tytul: string;
  temat?: string;
  pytanie?: string;
  opcje?: Array<HelpOption>;
  kroki?: Array<string>;
  uwaga?: string;
  dalej?: Array<HelpOption>;
}

export interface HelpReply {
  ok: boolean;
  start: Array<string>;
  wezly: Record<string, HelpNode>;
}

export interface GeoPoint {
  lat: number;
  lon: number;
}

export interface WeatherNow {
  temp: number | null;
  odczuwalna: number | null;
  wiatr: number | null;
  kierunek: number | null;
  wilgotnosc: number | null;
  cisnienie: number | null;
  opad: number | null;
  kod: number | null;
  opis: string;
  kiedy: number;
}

export interface WeatherReply {
  ok: boolean;
  lokalizacja: boolean;
  moznaUstawic: boolean;
  punkt: GeoPoint | null;
  zapytaj: boolean;
  pogoda: WeatherNow | null;
}

export interface GeoIn {
  lat: number;
  lon: number;
  usun: boolean;
}

export interface GeoSnoozeIn {
  za: "3d" | "7d" | "30d" | "nigdy";
}

export interface Progress {
  krok: number;
  przeczytane: Array<number>;
}

export interface ManualCardOut {
  id: string;
  tytul: string;
  opis: string;
  rozdzialy: number;
  kroki: number;
  twoje: boolean;
  okladka: string;
  linie: Array<string>;
  pdf: Array<string>;
  postep: Progress | null;
}

export interface ManualsReply {
  ok: boolean;
  instrukcje: Array<ManualCardOut>;
}

export interface PDF {
  nazwa: string;
  plik: string;
}

export interface Step {
  tytul: string;
  tekst: string;
  obraz?: string;
  animacja?: string;
  uwaga?: string;
  ostrzezenie?: string;
}

export interface Chapter {
  tytul: string;
  kroki: Array<Step>;
}

export interface Manual {
  id: string;
  tytul: string;
  opis: string;
  linie: Array<string>;
  pdf: Array<PDF>;
  rozdzialy: Array<Chapter>;
}

export interface ManualReply {
  ok: boolean;
  instrukcja: Manual;
  postep: Progress | null;
}

export interface ManualDocReply {
  ok: boolean;
  html: string;
}

export interface ManualProgressIn {
  krok: number;
  przeczytany: number;
}

export interface Category {
  id: string;
  nazwa: string;
}

export interface Badge {
  kod: string;
  ikona: IkonaOdznaki;
  nazwa: string;
  opis: string;
  kategoria: string;
  zdobyta: boolean;
  kiedy: string;
  postep: number;
  prog: number;
  jednostka: string;
  medal: string;
}

export interface Level {
  nr: number;
  nazwa: string;
  punkty: number;
  od: number;
  do: number;
}

export interface Domain {
  dziedzina: string;
  cykle: number;
  zdobyte: number;
  odznaki: Array<Badge>;
  poziom: Level;
}

export interface AchievementsReply {
  ok: boolean;
  kategorie: Array<Category>;
  dziedziny: Array<Domain>;
}

export interface Entry {
  miejsce: number;
  nazwa: string;
  odznaki: number;
  cykle: number;
  ty: boolean;
}

export interface Ranking {
  wiersze: Array<Entry>;
  twoje_miejsce: number;
  kont: number;
  zmiana: number | null;
}

export interface RankingReply {
  ok: boolean;
  ranking: Ranking;
}

export interface RMAContact {
  imie: string;
  email: string;
  telefon: string;
}

export interface RMAQuoteItem {
  nazwa: string;
  ilosc: number;
  cena: number;
}

export interface RMAAddress {
  imie: string;
  ulica: string;
  kod: string;
  miasto: string;
  telefon: string;
}

export interface RMAWorkshopOut {
  konto: number;
  usterka: UsterkaRMA | null;
  diagnoza: string;
  naprawa: string;
}

export interface RMATicketOut {
  id: number;
  numer: string;
  rodzaj: RodzajRMA;
  sn: string;
  sprzet: string;
  wersja: string;
  gwarancja_do: string | null;
  na_gwarancji: boolean;
  status: StatusRMA;
  status_nazwa: string;
  tytul: string;
  opis: string;
  kontakt: RMAContact;
  wycena: Array<RMAQuoteItem>;
  wycena_razem: number | null;
  decyzja: string | null;
  potrzebny_adres: boolean;
  adres: RMAAddress;
  przesylka_do_serwisu: string;
  przewoznik: string;
  przesylka_od_serwisu: string;
  wymienione: string;
  ocena: number | null;
  ocena_komentarz: string;
  nowe: boolean;
  utworzone: number;
  zmienione: number;
  zamkniete: number | null;
  warsztat?: RMAWorkshopOut | null;
}

export interface RMAListReply {
  ok: boolean;
  zgloszenia: Array<RMATicketOut>;
}

export interface RMAMessageOut {
  id: number;
  autor: string;
  tresc: string;
  wewnetrzna?: boolean;
  czas: number;
}

export interface RMAFileOut {
  id: number;
  nazwa: string;
  typ: string;
  rozmiar: number;
  od: string;
  wiadomosc: number | null;
  czas: number;
}

export interface RMAEventOut {
  zdarzenie: string;
  nazwa: string;
  notatka: string;
  kto: string;
  czas: number;
}

export interface RMAHistoryOut {
  id: number;
  numer: string;
  status: StatusRMA;
  usterka: UsterkaRMA | null;
  utworzone: number;
}

export interface RMARunOut {
  id: number;
  program: string;
  od: number;
  do: number | null;
  status: StatusPrzebiegu;
}

export interface RMAAlarmOut {
  id: number;
  sn: string;
  nazwa: string;
  waznosc: Waznosc;
  aktywny: boolean;
  temperatura: number | null;
  czas: number;
}

export interface RMAUnitOut {
  sn: string;
  wersja: string;
  przebiegi: Array<RMARunOut>;
  alarmy: Array<RMAAlarmOut>;
}

export interface RMAReply {
  ok: boolean;
  zgloszenie: RMATicketOut;
  wiadomosci: Array<RMAMessageOut>;
  pliki: Array<RMAFileOut>;
  os: Array<RMAEventOut>;
  historia?: Array<RMAHistoryOut>;
  sztuka?: RMAUnitOut | null;
}

export interface RMADeviceOut {
  id: number;
  sn: string;
  nazwa: string;
  sprzet: string;
  wersja: string;
  gwarancja_do: string | null;
  na_gwarancji: boolean;
}

export interface RMADevicesReply {
  ok: boolean;
  urzadzenia: Array<RMADeviceOut>;
  kontakt: RMAContact;
}

export interface RMACreateIn {
  rodzaj: RodzajRMA;
  sn: string;
  tytul: string;
  opis: string;
  kontakt: RMAContact;
}

export interface RMADecisionIn {
  akceptuje: boolean;
}

export interface RMAShipIn {
  numer: string;
}

export interface RMAMessageIn {
  tresc: string;
}

export interface RMAFileIn {
  nazwa: string;
  plik: string;
  w_wiadomosci: boolean;
  tekst: string;
}

export interface RMARateIn {
  ocena: number;
  komentarz: string;
}

export interface RMAChanged {
  user: number;
  id: number;
}

export interface AdminChanged {
  user: number;
  zakres: ZakresAdmina;
}

export interface RunAI {
  user: number;
  sn: string;
  przebieg: number;
  rodzaj: RodzajAI;
  tekst: string;
}

export interface LangsReply {
  ok: boolean;
  jezyk: JezykAPP;
  teksty: Record<string, string>;
}

export interface LangMissingIn {
  jezyk: JezykAPP;
  teksty: Array<string>;
}

export interface LangIn {
  jezyk: JezykAPP;
}

export interface AdminEntry {
  id: number;
  pytanie: string;
  odpowiedz: string;
  kat: string;
  zrodlo: string;
  url: string;
  tagi: Array<string>;
  status: "proposed" | "approved" | "rejected";
  rodzaj: string;
  pop: number;
  oceny_plus: number;
  oceny_minus: number;
  seria_minus: number;
  zrodlo_ref: string;
  zamienia_id: number | null;
  wycofaj: boolean;
  podobny_id: number | null;
  podobny_sim: number | null;
  podobny_pytanie: string;
  notatka: string;
  sprawdzil: string;
  dodano: number;
  sprawdzono: number | null;
  wektor: boolean;
}

export interface AdminEntriesReply {
  ok: boolean;
  wpisy: Array<AdminEntry>;
  dalej: boolean;
  liczby: Record<string, number>;
  kategorie: Array<string>;
  zrodla: Record<string, string>;
}

export interface AdminEntryIn {
  pytanie: string;
  odpowiedz: string;
  kat: string;
  url: string;
  notatka: string;
  tagi: Array<string>;
}

export interface AdminDoneReply {
  ok: boolean;
  id?: number;
  komunikaty: Array<string>;
}

export interface AdminIDsIn {
  ids: Array<number>;
}

export interface AdminMergeIn {
  cel: number;
  wez_tresc: boolean;
}

export interface AdminQuestion {
  id: number;
  kiedy: number;
  klient: "app" | "tablet" | "strona";
  konto: number | null;
  email: string;
  pytanie: string;
  odpowiedz: string;
  powod: string;
  status: "pending" | "done" | "rejected";
  skad: string;
  kod_filtra: string;
  filtr: string;
  wpis: number | null;
  film: string;
  ocena: number;
  podobienstwo: number | null;
  jezyk: string;
  tokeny_we: number;
  tokeny_wy: number;
  odpowiedziano: number | null;
}

export interface AdminQuestionsReply {
  ok: boolean;
  pytania: Array<AdminQuestion>;
  dalej: boolean;
}

export interface AdminKnowledge {
  id: number;
  dziedzina: string;
  kategoria: string | null;
  tytul: string;
  uzasadnienie: string;
  tresc: string;
  dowody: unknown;
  zastepuje: Array<number>;
  status: "pending" | "approved" | "rejected" | "superseded" | "withdrawn";
  cel: "wiedza" | "seo";
  utworzono: number;
  sprawdzono: number | null;
  skutecznosc?: string;
}

export interface AdminKnowledgeReply {
  ok: boolean;
  wiedza: Array<AdminKnowledge>;
  dalej: boolean;
}

export interface AdminKnowledgeIn {
  tytul: string;
  tresc: string;
  dziedzina: string;
  kategoria: string;
}

export interface RecipeCategoryIn {
  nazwa: string;
  dziedzina: DziedzinaPrzepisu | "";
}

export interface AdminRecipeOut {
  id: number;
  konto: number;
  platny: boolean;
  kolejnosc: number;
  szkic: boolean;
  email: string;
  login: string;
  wlasciciel: string;
  nazwa: string;
  opis: string;
  kategoria: number | null;
  kategoria_nazwa: string;
  wyrob: KategoriaWyrobu | "";
  rodzaj: RodzajPrzepisuAdmina;
  od: string;
  przyjeta: boolean;
  program_bazowy: string;
  z_cykli: number;
  lepiej: number;
  tak_samo: number;
  gorzej: number;
  program: unknown;
  zdjecia: number;
  utworzony: number;
  zmieniony: number;
}

export interface AdminRecipesReply {
  ok: boolean;
  przepisy: Array<AdminRecipeOut>;
  dalej: boolean;
}

export interface WetTable {
  woda_l_kg: number;
  warianty: Record<WariantPeklowania, Record<string, [number, number]>>;
  nastrzyk: Record<string, number>;
  ml_na_wklucie: number;
}

export interface DryTable {
  intensywnosc: Record<IntensywnoscPeklowania, number>;
  mieso: Record<MiesoPeklowania, number>;
  dni_na_kg: number;
  dni_min: number;
  zapas_na_kg: number;
  zapas_min: number;
}

export interface EQTable {
  procent: number;
  azotyn_proc: number;
  limit_mg_kg: number;
}

export interface BrineTable {
  procent: number;
  max_procent: number;
}

export interface Settings {
  mokro: WetTable;
  sucho: DryTable;
  eq: EQTable;
  solanka: BrineTable;
}

export interface CureSettingsReply {
  ok: boolean;
  tabela: Settings;
}

export interface GalleryEntryOut {
  id: number;
  sn: string;
  program: string;
  koniec: number | null;
  stan: StanGalerii;
  decyzja: number | null;
  konto: number;
  ma_zdjecie: boolean;
  analiza: string;
}

export interface GalleryEntriesReply {
  ok: boolean;
  wpisy: Array<GalleryEntryOut>;
  dalej: boolean;
  adres_strony: string;
}

export interface GalleryDecisionIn {
  stan: StanGalerii;
}

export interface GalleryPageIn {
  adres_strony: string;
}

export interface AdminRunOut {
  id: number;
  sn: string;
  adres: string;
  typ: TypLinii;
  konto: number;
  email: string;
  program: string;
  przepis: string;
  start: number;
  koniec: number | null;
  status: StatusPrzebiegu;
  proba: boolean;
  ocena: number | null;
  zdjecie: boolean;
  zdjecie_wsadu: boolean;
  ai_wstrzymane: boolean;
  stan_ai: StanAIPrzebiegu;
}

export interface AdminRunsReply {
  ok: boolean;
  przebiegi: Array<AdminRunOut>;
  dalej: boolean;
}

export interface AdminRunPhaseOut {
  nazwa: string;
  start: number;
  czas: number;
}

export interface AdminAdviceOut {
  id: number;
  sn: string;
  program: string;
  porada: string;
  uzasadnienie: string;
  stan: string;
  od: number;
  sprawdzona: number | null;
}

export interface AdminAIJobOut {
  id: number;
  rodzaj: string;
  stan: string;
  model: string;
  tokeny_we: number;
  tokeny_wy: number;
  blad: string;
  wynik: string;
  paczka: string;
  od: number;
  koniec: number | null;
}

export interface AdminRunReply {
  ok: boolean;
  przebieg: AdminRunOut;
  fazy: Array<AdminRunPhaseOut>;
  analiza: AnalysisReply;
  komentarz: string;
  zaladunek: LoadReply | null;
  porady: Array<AdminAdviceOut>;
  dziennik: Array<AdminAIJobOut>;
}

export interface AdminRunAIIn {
  wstrzymaj: boolean;
}

export interface AdminSeriesChannel {
  idx: number;
  etykieta: string;
  temat: string | null;
  wartosci: Array<number | null>;
}

export interface AdminSeriesEvent {
  typ: string;
  od_s: number;
  trwa_s: number | null;
  wznowiony: boolean | null;
}

export interface AdminRunSeriesReply {
  ok: boolean;
  przebieg: number;
  t0: number;
  krok: number;
  kanaly: Array<AdminSeriesChannel>;
  zdarzenia: Array<AdminSeriesEvent>;
  probki: number;
}

export interface RMAAdminListReply {
  ok: boolean;
  zgloszenia: Array<RMATicketOut>;
  dalej: boolean;
}

export interface RMACountOut {
  klucz: string;
  nazwa: string;
  ile: number;
}

export interface RMARepeatOut {
  sn: string;
  sprzet: string;
  ile: number;
  ostatnie: number;
}

export interface RMARatingOut {
  id: number;
  numer: string;
  ocena: number;
  komentarz: string;
  czas: number | null;
}

export interface RMAStatsReply {
  ok: boolean;
  wszystkie: number;
  otwarte: number;
  zdiagnozowane: number;
  gwarancyjne: number;
  ocenione: number;
  srednia_ocena: number;
  wg_sprzetu: Array<RMACountOut>;
  wg_wersji: Array<RMACountOut>;
  wg_usterki: Array<RMACountOut>;
  miesiace: Array<RMACountOut>;
  recydywa: Array<RMARepeatOut>;
  oceny: Array<RMARatingOut>;
}

export interface RMAScanIn {
  token: string;
}

export interface RMAScanReply {
  ok: boolean;
  id: number;
  numer: string;
  przyjeto: boolean;
  status_nazwa: string;
}

export interface RMAStatusIn {
  status: StatusRMA;
  notatka: string;
}

export interface RMAQuoteIn {
  pozycje: Array<RMAQuoteItem>;
  notatka: string;
}

export interface RMAAdminMessageIn {
  tresc: string;
  wewnetrzna: boolean;
}

export interface RMAWorkshopIn {
  usterka: UsterkaRMA | "";
  diagnoza: string;
  naprawa: string;
  przesylka_do_serwisu: string;
  przewoznik: string;
  przesylka_od_serwisu: string;
}

export interface RMAKindIn {
  rodzaj: RodzajRMA;
}

export interface RMASwapIn {
  sn: string;
}

export interface RMASwapReply {
  ok: boolean;
  kroki: Array<string>;
}

export interface DeviceDecisionIn {
  decyzja: "przyjmij" | "odrzuc";
  powod: string;
}

export interface ClaimNumberOut {
  sn: string;
  wynik: WynikProby;
  kiedy: number;
}

export interface ClaimAccountOut {
  konto: number;
  nazwa_konta: string;
  licznik: number;
  zablokowane: boolean;
  odrzucone: number;
  adresy: Array<string>;
  ostatnia: number;
  odblokowano: number | null;
  numery: Array<ClaimNumberOut>;
}

export interface ClaimAttemptsReply {
  ok: boolean;
  limit: number;
  konta: Array<ClaimAccountOut>;
  dalej: boolean;
}

export interface ClaimUnlockIn {
  konto: number;
}

export interface AdminAssignIn {
  konto: number;
}

export interface StationIn {
  sn: string;
  pub: string;
  typ: TypLinii;
  tryb: "new" | "legacy" | "";
  licencja_dni: number;
}

export interface StationReply {
  ok: boolean;
  sn: string;
  odcisk: string;
  klucz_znany: boolean;
  licencja: boolean;
  licencja_zalozona: boolean;
  licencja_wazna: boolean;
  tryb: string;
  tryb_byl: string;
  magazyn_zalozony: boolean;
  stare_haslo: boolean;
}

export interface StationPartOut {
  etykieta: string;
  adres: string;
  rozmiar: number;
  sha256: string;
}

export interface StationImageOut {
  nazwa: string;
  wersja: string;
  uklad: string;
  framework: string;
  czesci: Array<StationPartOut>;
  zmieniony: number;
}

export interface StationLineOut {
  typ: TypLinii;
  nazwa: string;
  tylko_new: boolean;
  licencja_dni: number;
  rodziny: Array<string>;
}

export interface StationImagesReply {
  ok: boolean;
  obrazy: Array<StationImageOut>;
  rodzaje: Array<StationLineOut>;
}

export interface StationPartIn {
  etykieta: string;
  adres: string;
  dane: string;
}

export interface StationImageIn {
  wersja: string;
  uklad: string;
  framework: "esp-idf" | "arduino" | "avr";
  czesci: Array<StationPartIn>;
}

export interface StationImageReply {
  ok: boolean;
  obraz: StationImageOut;
}

export interface StaffOut {
  konto: number;
  email: string;
  nazwa: string;
  firma: string;
  czynny: boolean;
  od: number;
}

export interface StaffReply {
  ok: boolean;
  serwisanci: Array<StaffOut>;
}

export interface StaffAddIn {
  email: string;
  firma: string;
}

export interface StaffSetIn {
  firma: string;
  czynny: boolean;
}

export interface ClaudeAccount {
  id: number;
  nazwa: string;
  notatka: string;
  token: string;
  wlaczone: boolean;
  zablokowane_do: number | null;
  powod: string;
  odrzucony: boolean;
  zuzycie_5h: number | null;
  odnowienie_5h: number | null;
  zuzycie_7d: number | null;
  odnowienie_7d: number | null;
  limity: number;
  ostatnio: number | null;
}

export interface ClaudeUsage {
  program: string;
  rodzaj: string;
  wywolania_1d: number;
  tokeny_1d: number;
  wywolania_7d: number;
  tokeny_7d: number;
  wywolania_30d: number;
  tokeny_30d: number;
  limity_30d: number;
}

export interface ClaudeThresholds {
  tlo: number;
  stop: number;
}

export interface ClaudeAccountsReply {
  ok: boolean;
  konta: Array<ClaudeAccount>;
  zuzycie: Array<ClaudeUsage>;
  progi: ClaudeThresholds;
  modele: Record<FunkcjaAI, string>;
  dostepne: Array<string>;
}

export interface ClaudeAccountIn {
  nazwa: string;
  notatka: string;
  token: string;
  wlaczone: boolean;
}

export interface ClaudeModelsIn {
  modele: Partial<Record<FunkcjaAI, string>>;
}

export interface ClaudeTokenIn {
  token: string;
}

export interface LangTextOut {
  hash: string;
  pl: string;
  tlumaczenie: string;
  poprawione: boolean;
  zmienione: number;
}

export interface LangTextsReply {
  ok: boolean;
  teksty: Array<LangTextOut>;
  dalej: boolean;
}

export interface LangCorrectIn {
  tlumaczenie: string;
}

export interface GlossaryOut {
  id: number;
  pl: string;
  tlumaczenie: string;
}

export interface GlossaryReply {
  ok: boolean;
  terminy: Array<GlossaryOut>;
}

export interface GlossaryIn {
  pl: string;
  tlumaczenie: string;
}

export interface AdminBridgeOut {
  przez: string;
  od_s: number;
}

export interface AdminPresenceOut {
  online: boolean;
  stan: string;
  ostatnia_ramka_s: number | null;
  most?: AdminBridgeOut | null;
}

export interface AdminPresenceReply {
  ok: boolean;
  obecnosc: Record<string, AdminPresenceOut>;
}

export interface AdminMQTTIn {
  temat: string;
  tresc: string;
}

export interface AdminMQTTReply {
  ok: boolean;
  temat: string;
}

export interface AdminCopyOut {
  id: string;
  rola: string;
  wersja: string;
  serwer: string;
  obciazenie: number;
  start: number;
  meldunek: number;
  mierniki: Record<string, number>;
  wiadomosci_na_min: number | null;
}

export interface AdminClusterConfig {
  serwer: string;
  valkey_tryb: "pojedynczy" | "sentinel" | "klaster";
  valkey_wezly: Array<string>;
  baza_zapis: string;
  baza_odczyt: string;
  mqtt: string;
  pliki: string;
}

export interface AdminClusterCheck {
  co: string;
  ok: boolean;
  wymagany: boolean;
  opis: string;
}

export interface AdminLooperOut {
  login: string;
  proby: number;
}

export interface AdminHAProxyOut {
  cisza_s: number | null;
  minuty: Array<Record<string, number>>;
  zapetlone: Array<AdminLooperOut>;
}

export interface AdminClusterReply {
  ok: boolean;
  kopie: Array<AdminCopyOut>;
  wersje_rozne: boolean;
  konfiguracja: AdminClusterConfig;
  warunki: Array<AdminClusterCheck>;
  haproxy: AdminHAProxyOut;
}

export interface CertProbe {
  id: string;
  label: string;
  host: string;
  sni: string;
  port: number;
  kind: string;
  ok: boolean;
  error?: string;
  trusted: boolean;
  trustError: string | null;
  subject: string | null;
  issuer: string | null;
  san: Array<string>;
  validFrom: string | null;
  validTo: string | null;
  daysLeft: number | null;
  status: string;
}

export interface CertbotCert {
  name: string;
  domains: Array<string>;
  expiry: string | null;
  valid: boolean | null;
  note: string;
}

export interface CertbotState {
  certificates: Array<CertbotCert>;
  timer: Record<string, string | null>;
  log: Array<string>;
}

export interface BackupState {
  at: string;
  mariadb: number;
  postgres: number;
  bucket: string;
}

export interface CertReport {
  warnDays: number;
  critDays: number;
  checkedAt: string;
  targets: Array<CertProbe>;
  certbot: CertbotState | null;
  certbotError?: string;
  kopia: BackupState | null;
  kopiaError?: string;
}

export interface AdminCertsReply {
  ok: boolean;
  stan: CertReport | null;
}

export interface AdminStatsResetIn {
  program: string;
}

export interface AdminStatsResetReply {
  ok: boolean;
  programy: Array<string>;
  od: string;
}

export interface AdminOTATarget {
  sn: string;
  tryb: string;
}

export interface AdminOTAIn {
  sn: string;
  haslo: string;
  cele: Array<AdminOTATarget>;
  obraz: string;
}

export interface AdminOTAQueued {
  sn: string;
  tryb: string;
  temat: string;
}

export interface AdminOTAReply {
  ok: boolean;
  url: string;
  cele: Array<AdminOTAQueued>;
}

export interface AdminFirmwareFamilyOut {
  rodzina: string;
  wersja: string;
  rozmiar: number;
  sha256: string;
  wymus: boolean;
}

export interface AdminFirmwareFamiliesReply {
  ok: boolean;
  rodziny: Array<AdminFirmwareFamilyOut>;
}

export interface AdminFirmwarePublishIn {
  wersja: string;
  podpis: string;
  wymus: boolean;
  punktowo: boolean;
  obraz: string;
}

export interface AdminFirmwarePublishReply {
  ok: boolean;
  wersja: string;
  plik: string;
  rozmiar: number;
  sha256: string;
  klucz: number;
  wymus: boolean;
  ogloszona: boolean;
}

export interface AdminFirmwareVersionOut {
  wersja: string;
  plik: string;
  zmieniona: number;
}

export interface AdminFirmwareVersionsReply {
  ok: boolean;
  wersje: Array<AdminFirmwareVersionOut>;
  dalej: boolean;
}

export interface AdminFirmwareAnnounceIn {
  wersja: string;
}

export interface AdminFirmwareAnnounceReply {
  ok: boolean;
  wersja: string;
  poprzednia: string;
  wymus: boolean;
}

export interface AdminFirmwareDeleteReply {
  ok: boolean;
  usuniete: Array<string>;
}

export interface AdminOTALogOut {
  czas: number;
  sn: string;
  rodzina: string;
  droga: string;
  wersja_sztuki: string;
  wersja_oferowana: string;
  kod: number;
  wynik: string;
  pin: string;
  rozmiar: number;
  ip: string;
  ms: number;
}

export interface AdminOTALogReply {
  ok: boolean;
  wpisy: Array<AdminOTALogOut>;
  dalej: boolean;
}

export interface AdminDeviceOut {
  sn: string;
  adres: string;
  typ: TypLinii;
  nazwa: string;
  konto: number;
  email: string;
  login: string;
  wlasciciel: string;
  wersja: string;
  licencja: string;
  licencja_do: string;
  tryb: string;
  obecnosc: AdminPresenceOut | null;
  ostatni_przebieg: number | null;
  kod_obslugiwany: boolean;
  kod_wyslany: boolean;
  ota_mqtt: boolean;
  czeka_na_zgode: boolean;
}

export interface AdminDevicesReply {
  ok: boolean;
  urzadzenia: Array<AdminDeviceOut>;
  dalej: boolean;
}

export interface AdminLicenseOut {
  tryb: string;
  wazna: boolean;
  dni: number;
  wylaczona: boolean;
  haslo_legacy: boolean;
  sprzet: string;
  do: string;
  gwarancja_do: string;
  kod: number | null;
  kod_wyslany: number | null;
  dystrybutor: string;
  klient: string;
  adres: string;
  telefon: string;
  email: string;
  notatka: string;
  utworzona: number;
  zmieniona: number;
}

export interface AdminAuthOut {
  nazwa: string;
  odcisk: string;
  wydane: number;
  wymiana: number | null;
  wydan: number;
}

export interface AdminPendingOut {
  odcisk: string;
  pierwsze: number;
  ostatnie: number;
  prob: number;
  zgoda: number | null;
  zgoda_konto: number | null;
}

export interface AdminPinOut {
  rodzina: string;
  wersja: string;
  ustawiony: number;
  kto: string;
  notatka: string;
  wydany: number | null;
  potwierdzony: number | null;
  wydan: number;
  ostatnia_wersja: string;
  ostatnio: number | null;
}

export interface AdminModuleOut {
  sn: string;
  typ: string;
  dozwolony: boolean;
  sparowany: boolean;
  lacznosc: boolean | null;
  rssi: number | null;
}

export interface AdminConnAttemptOut {
  login: string;
  czas: number;
  ip: string;
  wynik: string;
  ms: number;
  wyslane: number;
  odebrane: number;
  zakonczenie: string;
}

export interface AdminConnOut {
  werdykt: "polaczona" | "brak" | "cisza" | "obcy" | "wygasly" | "hamulec" | "odmowa" | "zerwana" | "bez_loginu" | "rozlaczona";
  opis: string;
  proby: Array<AdminConnAttemptOut>;
}

export interface AdminDeviceCardReply {
  ok: boolean;
  sn: string;
  id: number;
  urzadzenie: AdminDeviceOut | null;
  firmware: Record<string, string>;
  sprzet: Record<string, string | null>;
  notatka: string;
  zrodlo_przypisania: string;
  przypisane: number | null;
  dodane: number | null;
  udostepnienia: Array<ShareOut>;
  licencja: AdminLicenseOut | null;
  hasla: Array<AdminAuthOut>;
  oczekuje: AdminPendingOut | null;
  piny: Array<AdminPinOut>;
  dziennik_ota: Array<AdminOTALogOut>;
  moduly: Array<AdminModuleOut>;
  alarmy: Array<RMAAlarmOut>;
  przebiegi: Array<RMARunOut>;
  proby: number;
  polaczenie: AdminConnOut;
}

export interface AdminClientOut {
  id: number;
  email: string;
  login: string;
  nazwa: string;
  rejestracja: number | null;
  aktywne: boolean;
  admin: boolean;
  zablokowane: boolean;
  urzadzenia: number;
  ostatnie_logowanie: number | null;
}

export interface AdminClientsReply {
  ok: boolean;
  klienci: Array<AdminClientOut>;
  dalej: boolean;
}

export interface AdminAccessOut {
  sn: string;
  nazwa: string;
  typ: TypLinii;
  rola: Rola;
  klient: string;
}

export interface AdminSubscriptionOut {
  id: number;
  produkt: string;
  wlaczona: boolean;
  do: number;
  zamowienie: number;
  od: number;
}

export interface AdminLoginOut {
  id: number;
  czas: number;
  konto: number;
  login: string;
  sposob: string;
  ok: boolean;
  kod: string;
  ip: string;
  przegladarka: string;
  system: string;
}

export interface AdminMemoOut {
  id: number;
  sn: string;
  program: string;
  rodzaj: string;
  tresc: string;
  waga: number;
  stan: string;
  zmiana: number;
}

export interface AdminClientCardReply {
  ok: boolean;
  konto: AdminClientOut;
  dane: Record<string, string>;
  urzadzenia: Array<AdminDeviceOut>;
  urzadzenia_dalej: boolean;
  dostepy: Array<AdminAccessOut>;
  subskrypcje: Array<AdminSubscriptionOut>;
  telefony: Array<PhoneOut>;
  alarmy: Array<RMAAlarmOut>;
  rma: Array<RMATicketOut>;
  wnioski: Array<DeviceRequestOut>;
  serwis: Array<GrantOut>;
  serwis_klienci: Array<GrantOut>;
  logowania: Array<AdminLoginOut>;
  porady: Array<AdminAdviceOut>;
  pamiec: Array<AdminMemoOut>;
}

export interface AdminLoginsReply {
  ok: boolean;
  logowania: Array<AdminLoginOut>;
  dalej: boolean;
}

export interface AdminBlockedUserOut {
  konto: number;
  email: string;
  login: string;
  nazwa: string;
  notatka: string;
  od: number;
}

export interface AdminBlockedIPOut {
  ip: string;
  konto: number;
  notatka: string;
  od: number;
}

export interface AdminBlocksReply {
  ok: boolean;
  konta: Array<AdminBlockedUserOut>;
  adresy: Array<AdminBlockedIPOut>;
}

export interface AdminDashDevicesOut {
  wszystkie: number;
  u_klientow: number;
  online: number;
}

export interface AdminDashOnlineOut {
  czas: number;
  online: number;
  wszystkie: number;
}

export interface AdminDashTodoOut {
  rma_otwarte: number;
  rma_nowe: number;
  rma_od_klienta: number;
  wnioski: number;
  obce: number;
  wiedza: number;
  asystent: number;
  galeria: number;
}

export interface AdminDashAlarmsOut {
  wszystkie: number;
  krytyczne: number;
  ostrzezenia: number;
  urzadzenia: number;
}

export interface AdminDashAIOut {
  wywolania: number;
  tokeny: number;
  konta: number;
  konta_zablokowane: number;
  zuzycie_5h: number | null;
  zuzycie_7d: number | null;
}

export interface AdminDashSalesOut {
  subskrypcje_czynne: number;
  subskrypcje_nowe: number;
  subskrypcje_platne: number;
}

export interface AdminDashboardReply {
  ok: boolean;
  czas: number;
  urzadzenia: AdminDashDevicesOut;
  online_wykres: Array<AdminDashOnlineOut>;
  do_zrobienia: AdminDashTodoOut;
  alarmy: AdminDashAlarmsOut;
  ai: AdminDashAIOut;
  sprzedaz: AdminDashSalesOut;
}

export interface AdminCountersReply {
  ok: boolean;
  agenci: number;
  szkice: number;
}

export interface AdminLicenseIn {
  do?: string | null;
  wylaczona?: boolean | null;
  sprzet?: string | null;
  klient?: string | null;
  notatka?: string | null;
  tryb?: "new" | "legacy";
}

export interface AdminApproveIn {
  odcisk: string;
}

export interface AdminPinIn {
  rodzina: string;
  wersja: string;
  notatka: string;
}

export interface AdminUnknownOut {
  sn: string;
  kanal: string;
  ostatni_kanal: string;
  tryb: string;
  rodzina: string;
  wersja: string;
  ip: string;
  numerow_z_ip: number;
  prob: number;
  pierwsze: number;
  ostatnie: number;
  stan: string;
  decyzja: number | null;
  kto: string;
}

export interface AdminUnknownReply {
  ok: boolean;
  numery: Array<AdminUnknownOut>;
  dalej: boolean;
}

export interface AdminUnknownIn {
  numery: Array<string>;
  stan?: "obsluzony" | "odrzucony";
}

export interface AdminSeoPhraseOut {
  id: number;
  fraza: string;
  zrodlo: ZrodloFrazySeo;
  seed: string;
  stan: StanFrazySeo;
  uwaga: string;
  dodana: number;
  pozycja: number;
  pozycja_wczesniej: number;
  wyswietlenia: number;
  klikniecia: number;
  stare_okno: boolean;
  strona: string;
  okazja: OkazjaFrazy | "";
  sprawdzenie: number;
  sprawdzenie_stan: StanSprawdzeniaSeo | "";
  sprawdzenie_pozycja: number;
}

export interface AdminSeoPhrasesReply {
  ok: boolean;
  frazy: Array<AdminSeoPhraseOut>;
  dalej: boolean;
}

export interface AdminGooglePhraseOut {
  fraza: string;
  klikniecia: number;
  wyswietlenia: number;
  pozycja: number;
}

export interface AdminGooglePageOut {
  sciezka: string;
  adres: string;
  wyswietlenia: number;
  klikniecia: number;
  pozycja: number;
  zamowienia: number;
  kwota: number;
  oceny: OcenaStrony[];
  frazy: Array<AdminGooglePhraseOut>;
}

export interface AdminGooglePagesReply {
  ok: boolean;
  strony: Array<AdminGooglePageOut>;
  klikniecia: number;
  zamowienia: number;
  kwota: number;
  do_poprawy: number;
  pomiar: string;
  blad_sklepu: string;
}

export interface GA4Week {
  tydzien: string;
  od: string;
  do: string;
  biezacy: boolean;
  odwiedzajacy: number;
  sesje: number;
  produkt: number;
  koszyk: number;
  kasa: number;
  zakup: number;
  bledy_kasy: number;
  zamowienia: number;
  przychod: number;
}

export interface GA4CheckoutError {
  pole: string;
  komunikat: string;
  ile: number;
  osoby: number;
}

export interface GA4Source {
  zrodlo: string;
  sesje: number;
  koszyk: number;
  kasa: number;
  zamowienia: number;
  przychod: number;
}

export interface GA4Reel {
  slug: string;
  zrodla: Array<string>;
  sesje: number;
  zaangazowane: number;
  koszyk: number;
  kasa: number;
  zamowienia: number;
  przychod: number;
}

export interface GA4Report {
  wygenerowano: number;
  lejek_od: string;
  dni30_od: string;
  rolki_od: string;
  do: string;
  lejek: Array<GA4Week>;
  bledy_kasy: Array<GA4CheckoutError>;
  zrodla: Array<GA4Source>;
  rolki: Array<GA4Reel>;
  bledy: Array<string>;
}

export interface AdminShopReply {
  ok: boolean;
  raport: GA4Report | null;
}

export interface AdminSeoPhraseInfo {
  id: number;
  fraza: string;
  zrodlo: ZrodloFrazySeo;
  seed: string;
  stan: StanFrazySeo;
  dodana: number;
  zmiana: number;
}

export interface AdminSeoRankOut {
  dzien: string;
  okno: number;
  strona: string;
  wyswietlenia: number;
  klikniecia: number;
  ctr: number;
  pozycja: number;
}

export interface Organic {
  poz: number;
  url: string;
  tytul: string;
  opis: string;
}

export interface PageLayout {
  ai_przeglad: boolean;
  reklamy: boolean;
  wideo: boolean;
  mapa: boolean;
  zakupy: boolean;
}

export interface Findings {
  wyniki: Array<Organic>;
  paa: Array<string>;
  powiazane: Array<string>;
  podpowiedzi: Array<string>;
  uklad: PageLayout;
}

export interface Rival {
  url: string;
  powod: string;
}

export interface TopicPick {
  fraza: string;
  warta_tematu: boolean;
  powod: string;
}

export interface Assessment {
  podsumowanie: string;
  dlaczego_wyzej: Array<Rival>;
  co_poprawic: Array<string>;
  kandydaci: Array<TopicPick>;
}

export interface AdminSeoCheckOut {
  id: number;
  stan: StanSprawdzeniaSeo;
  prob: number;
  z_panelu: boolean;
  zlecone: number;
  start: number | null;
  koniec: number | null;
  pozycja: number | null;
  nasz_url: string;
  wynik: Findings | null;
  ocena: Assessment | null;
  blad: string;
}

export interface AdminSeoPhraseReply {
  ok: boolean;
  fraza: AdminSeoPhraseInfo;
  pomiary: Array<AdminSeoRankOut>;
  sprawdzenia: Array<AdminSeoCheckOut>;
}

export interface AdminSeoStatusIn {
  id: Array<number>;
  stan: StanFrazySeo;
}

export interface AdminSeoQueryIn {
  fraza: string;
}

export interface AdminSeoQueueOut {
  id: number;
  fraza_id: number;
  fraza: string;
  stan: StanSprawdzeniaSeo;
  prob: number;
  zlecil: string;
  zlecone: number;
  koniec: number | null;
  pozycja: number | null;
  blad: string;
  wykonawca: string;
  poprzednie: number;
  pozycja_wczesniej: number | null;
}

export interface AdminSeoQueueReply {
  ok: boolean;
  sprawdzenia: Array<AdminSeoQueueOut>;
  dalej: boolean;
}

export interface AdminExecutorOut {
  id: number;
  rodzaj: RodzajWykonawcy;
  nazwa: string;
  adres: string;
  aktywny: boolean;
  dodany: number;
  klucz_zmieniony: number | null;
  ostatni_kontakt: number | null;
}

export interface AdminExecutorsReply {
  ok: boolean;
  wykonawcy: Array<AdminExecutorOut>;
}

export interface AdminExecutorIn {
  rodzaj?: RodzajWykonawcy;
  nazwa: string;
  adres: string;
  aktywny: boolean;
}

export interface AdminExecutorKeyReply {
  ok: boolean;
  id: number;
  klucz: string;
}

export interface AdminExecutorCallOut {
  id: number;
  wykonawca: string;
  kiedy: number;
  trasa: string;
  zlecenie: number | null;
  kod: number;
  ip: string;
  uwaga: string;
}

export interface AdminExecutorCallsReply {
  ok: boolean;
  wywolania: Array<AdminExecutorCallOut>;
  dalej: boolean;
}

export interface Label {
  tekst: string;
  x: number;
  y: number;
  rozmiar: "sm" | "md" | "lg";
  strzalka: "" | "left" | "right" | "up" | "down";
}

export interface AdminImageOut {
  id: number;
  rodzaj: RodzajGrafiki;
  odniesienie: string;
  prompt: string;
  format: string;
  napisy: Array<Label>;
  dostawca: string;
  uzyty: string;
  stan: StanGrafiki;
  prob: number;
  szerokosc: number;
  wysokosc: number;
  blad: string;
  zlecone: number;
  start: number | null;
  koniec: number | null;
  zlecil: string;
  wykonawca: string;
}

export interface AdminImageProviderOut {
  dostawca: string;
  przerwa_do: number | null;
  ostatni_blad: string;
}

export interface AdminImagesReply {
  ok: boolean;
  zlecenia: Array<AdminImageOut>;
  dostawcy: Array<AdminImageProviderOut>;
  dalej: boolean;
}

export interface AdminImageReply {
  ok: boolean;
  zlecenie: AdminImageOut;
}

export interface AdminImageIn {
  rodzaj: RodzajGrafiki;
  odniesienie: string;
  prompt: string;
  format: string;
  dostawca: string;
  napisy: Array<Label>;
}

export interface AdminImageIDsIn {
  id: Array<number>;
}

export interface AdminImageBriefIn {
  prompt: string;
  napisy: Array<Label>;
}

export interface AdminImageFileIn {
  plik: string;
}

export interface AdminAgentExecutorNow {
  nazwa: string;
  rodzaj: RodzajWykonawcy;
  aktywny: boolean;
  ostatni_kontakt: number | null;
  milczy: boolean;
}

export interface AdminAgentsNow {
  serp_czeka: number;
  serp_w_toku: number;
  serp_ocena: number;
  obrazy_czeka: number;
  obrazy_w_toku: number;
  gsc_ostatni_dzien: string;
  wykonawcy: Array<AdminAgentExecutorNow>;
  dostawcy: Array<AdminImageProviderOut>;
}

export interface AdminAgentEventOut {
  id: number;
  kiedy: number;
  program: ProgramAgenta;
  rodzaj: string;
  waga: WagaZdarzenia;
  tytul: string;
  tresc: string;
  odniesienie: string;
  push: number | null;
  przeczytane: boolean;
}

export interface AdminAgentsReply {
  ok: boolean;
  teraz: AdminAgentsNow;
  rodzaje: Array<string>;
  zdarzenia: Array<AdminAgentEventOut>;
  dalej: boolean;
}

export interface AdminLiveStepOut {
  id: number;
  kiedy: number;
  rodzaj: RodzajKroku;
  tresc: string;
}

export interface AdminLiveCallOut {
  id: number;
  program: string;
  zadanie: string;
  model: string;
  konto: string;
  wynik: WynikWywolania;
  tokeny_we: number;
  tokeny_wy: number;
  start: number;
  koniec: number | null;
  krokow: number;
  kroki: Array<AdminLiveStepOut>;
}

export interface AdminLiveReply {
  ok: boolean;
  wywolania: Array<AdminLiveCallOut>;
}

export interface AdminAgentsReadIn {
  id: number;
}

export interface AdminAgentEventReply {
  ok: boolean;
  zdarzenie: AdminAgentEventOut;
}

export interface AdminReelPubOut {
  platforma: PlatformaRolki;
  stan: StanPublikacjiRolki;
  wersja: number;
  adres: string;
  info: string;
  blad: string;
  komentarz: boolean;
  przypiety: boolean;
  blad_przypiecia: string;
  ponow_po: number | null;
  opublikowana: number | null;
}

export interface AdminReelOut {
  id: number;
  slug: string;
  nazwa: string;
  wersja: number;
  stan: StanRolki;
  dlugosc_s: number | null;
  utworzona: number;
  przejrzana: number | null;
  opublikowana: number | null;
  publikacje: Array<AdminReelPubOut>;
}

export interface AdminReelsReply {
  ok: boolean;
  rolki: Array<AdminReelOut>;
  dalej: boolean;
}

export interface ReelYouTubeForm {
  tytul: string;
  opis: string;
  tagi: Array<string>;
  prywatnosc: PrywatnoscYouTube;
  kiedy: string;
}

export interface ReelTikTokForm {
  opis: string;
  prywatnosc: string;
  komentarze: boolean;
  duet: boolean;
  stitch: boolean;
  twoja_marka: boolean;
  partner: boolean;
}

export interface Meta {
  youtube: ReelYouTubeForm;
  tiktok: ReelTikTokForm;
}

export interface ReelOptions {
  platformy: Array<PlatformaRolki>;
  youtube: ReelYouTubeForm;
  tiktok: ReelTikTokForm;
  ai: boolean | null;
  ponownie: boolean;
}

export interface AdminReelReply {
  ok: boolean;
  rolka: AdminReelOut;
  plik: boolean;
  meta: Meta;
  formularz: ReelOptions | null;
  polaczone: Array<PlatformaRolki>;
  tryb_tiktok: TrybTikToka;
}

export interface AdminReelReviewIn {
  stan: StanRolki;
}

export interface AdminTikTokCreatorReply {
  ok: boolean;
  nazwa: string;
  widocznosci: Array<string>;
  bez_komentarzy: boolean;
  bez_duetu: boolean;
  bez_stitch: boolean;
  maks_s: number;
}

export interface AdminReelAccountOut {
  platforma: PlatformaRolki;
  klient: string;
  ma_sekret: boolean;
  polaczone: boolean;
  nazwa: string;
  tryb: TrybTikToka;
  polaczone_od: number | null;
  wazne_do: number | null;
  adres_powrotu: string;
}

export interface AdminReelAccountsReply {
  ok: boolean;
  konta: Array<AdminReelAccountOut>;
  bez_klucza: boolean;
}

export interface AdminReelAppIn {
  klient: string;
  sekret: string;
  tryb: TrybTikToka;
}

export interface AdminReelConsentReply {
  ok: boolean;
  adres: string;
}

export interface AdminReelCodeIn {
  kod: string;
  stan: string;
}

export interface AdminReelCommentOut {
  id: string;
  film: string;
  rolka_id: number | null;
  rolka: string;
  autor: string;
  awatar: string;
  tresc: string;
  polubienia: number;
  kiedy: number;
  odpowiedziany: boolean;
  stan: StanKomentarzaRolki;
  odpowiedz: string;
  blad: string;
  podpowiedz: string;
  stan_podpowiedzi: StanPodpowiedziRolki;
}

export interface AdminReelCommentsReply {
  ok: boolean;
  komentarze: Array<AdminReelCommentOut>;
  dalej: boolean;
}

export interface AdminReelReplyIn {
  tresc: string;
}

export interface AdminReelMarkIn {
  stan: StanKomentarzaRolki;
}

export interface AdminReelWeekOut {
  obserwujacy: number | null;
  wyswietlenia: number | null;
}

export interface AdminReelAccountStatOut {
  platforma: PlatformaRolki;
  dzien: string;
  obserwujacy: number | null;
  wyswietlenia: number | null;
  filmy: number | null;
  polubienia: number | null;
  tydzien_temu: AdminReelWeekOut | null;
}

export interface AdminReelFilmOut {
  platforma: PlatformaRolki;
  film: string;
  tytul: string;
  adres: string;
  opublikowany: number | null;
  wyswietlenia: number;
  polubienia: number;
  komentarze: number;
  udostepnienia: number | null;
  rolka: string;
  zaangazowane: number | null;
  sredni_czas_s: number | null;
  sredni_procent: number | null;
  subskrypcje: number | null;
}

export interface AdminReelTrafficOut {
  zrodlo: string;
  wyswietlenia: number;
}

export interface AdminReelStatsReply {
  ok: boolean;
  konta: Array<AdminReelAccountStatOut>;
  filmy: Array<AdminReelFilmOut>;
  zrodla: Array<AdminReelTrafficOut>;
  sklep: Array<GA4Reel>;
  sklep_od: string;
}

export interface AdminTopicOut {
  id: number;
  tytul: string;
  fraza: string;
  zrodlo: ZrodloTematu;
  powod: string;
  priorytet: number;
  wynik: number;
  stan: StanTematu;
  teraz: boolean;
  prob: number;
  blad: string;
  wpis_wp: number | null;
  adres_wp: string;
  stan_wp: string;
  wersji: number;
  uwagi_faktow: string;
  dodany: number;
  napisany: number | null;
}

export interface AdminTopicsReply {
  ok: boolean;
  tematy: Array<AdminTopicOut>;
  dalej: boolean;
}

export interface AdminTopicNewIn {
  tytul: string;
  fraza: string;
  uwagi: string;
  teraz: boolean;
  mimo_podobnego: boolean;
}

export interface AdminArticleImageOut {
  rola: string;
  alt: string;
  zlecenie: number;
}

export interface AdminArticleOut {
  wersja: number;
  tytul: string;
  seo_tytul: string;
  opis: string;
  zajawka: string;
  fraza: string;
  slug: string;
  tagi: Array<string>;
  html: string;
  obrazy: Array<AdminArticleImageOut>;
  uwagi_faktow: string;
  model: string;
  napisana: number;
}

export interface AdminTopicReply {
  ok: boolean;
  temat: AdminTopicOut;
  uwagi: string;
  sprawdzony_wp: number | null;
  wersje: Array<AdminArticleOut>;
}

export interface AdminTopicForceIn {
  uwagi: string;
}

export interface AdminTopicPriorityIn {
  priorytet: number;
}

export interface AdminFaqOut {
  fraza_id: number;
  fraza: string;
  stan_frazy: StanFrazySeo;
  pytanie: string;
  odpowiedz: string;
  stan: StanFaq;
  uwagi: string;
  prob: number;
  podobienstwo: number;
  strona: number;
  tytul_strony: string;
  adres_strony: string;
  zmiana: number;
}

export interface AdminFaqReply {
  ok: boolean;
  pytania: Array<AdminFaqOut>;
  dalej: boolean;
}

export interface AdminFactIssueOut {
  id: number;
  strona: number;
  tytul_strony: string;
  adres_strony: string;
  zrodlo: ZrodloBleduFaktow;
  waga: WagaBleduFaktow;
  dotyczy: string;
  cytat: string;
  poprawnie: string;
  stan: StanBleduFaktow;
  uwagi: string;
  znaleziony: number;
  ostatnio: number;
}

export interface AdminFactIssuesReply {
  ok: boolean;
  bledy: Array<AdminFactIssueOut>;
  dalej: boolean;
}

export interface AdminProblemOut {
  id: number;
  rodzaj: RodzajProblemuSeo;
  adres: string;
  waga: WagaProblemuSeo;
  tytul: string;
  opis: string;
  poprawka: string;
  stan: StanProblemuSeo;
  uwagi: string;
  znaleziony: number;
  ostatnio: number;
}

export interface AdminProblemsReply {
  ok: boolean;
  problemy: Array<AdminProblemOut>;
  dalej: boolean;
}

export interface AdminCheckRunOut {
  id: number;
  rodzaj: RodzajKontroliSeo;
  ocena: number | null;
  nowych: number;
  model: string;
  kiedy: number;
}

export interface AdminCheckRunsReply {
  ok: boolean;
  kontrole: Array<AdminCheckRunOut>;
  dalej: boolean;
}

export interface AdminCheckRunReply {
  ok: boolean;
  kontrola: AdminCheckRunOut;
  raport: string;
}

export interface AdminIndexOut {
  adres: string;
  tytul: string;
  rodzaj: RodzajIndeksacji;
  od: number;
  stan: StanIndeksacji;
  werdykt: string;
  pokrycie: string;
  przeszukana: number | null;
  sprawdzona: number | null;
  prob: number;
}

export interface AdminIndexReply {
  ok: boolean;
  strony: Array<AdminIndexOut>;
  dalej: boolean;
}

export interface AdminPageviewOut {
  strona: number;
  typ: string;
  tytul: string;
  adres: string;
  teraz: number;
  wczesniej: number;
  miesiac: number;
  stan: StanOdslon;
}

export interface AdminPageviewsReply {
  ok: boolean;
  tresci: Array<AdminPageviewOut>;
  dalej: boolean;
}

export interface AdminUpvoteOut {
  strona: number;
  typ: string;
  tytul: string;
  adres: string;
  suma: number;
  d7: number;
  d30: number;
  ostatni: number | null;
}

export interface AdminUpvotesReply {
  ok: boolean;
  suma: number;
  d7: number;
  d30: number;
  wpisy: number;
  odczyt: number | null;
  lapki: Array<AdminUpvoteOut>;
  dalej: boolean;
}

export interface AdminTesterOrderOut {
  od: number;
  rola: number;
  poziom: number;
  grupy: string;
  miesiace: number;
}

export interface AdminTesterOut {
  sn: string;
  opis: string;
  wlasciciel: number | null;
  konto: number;
  grupa: string;
  rola: number;
  poziom: number;
  grupy: string;
  wazny_do: number | null;
  wystawiony: number | null;
  certyfikat: boolean;
  cert_seq: number;
  cert_odebrany_seq: number;
  cert_odebrany: number | null;
  odwolany: number | null;
  dodany: number;
  zlecenie: AdminTesterOrderOut | null;
  ma_klucz: boolean;
}

export interface AdminTestersReply {
  ok: boolean;
  testery: Array<AdminTesterOut>;
}

export interface AdminTesterEditIn {
  wlasciciel: number | null;
  grupa: string;
  opis: string;
}

export interface AdminTesterRoleOut {
  rola_przed: number;
  rola_po: number;
  cert_seq: number;
  wazny_do: number | null;
  kto: number;
  zrodlo: string;
  uwagi: string;
  kiedy: number;
}

export interface AdminTesterRolesReply {
  ok: boolean;
  historia: Array<AdminTesterRoleOut>;
}

export interface AdminTesterOrderIn {
  rola: number;
  poziom: number;
  grupy: string;
  miesiace: number;
}

export interface AdminTesterRevokeIn {
  odwolany: boolean;
  uwagi: string;
}

export interface AdminTesterRevokeReply {
  ok: boolean;
  sterowniki: number;
}

export interface AdminTesterTypeOut {
  typ: number;
  nazwa: string;
  grupa: number;
  wersja: number;
  zmiana: number;
}

export interface AdminTesterTypesReply {
  ok: boolean;
  typy: Array<AdminTesterTypeOut>;
}

export interface Output {
  bit: number;
  nazwa: string;
  json: string;
  rodzaj: string;
  slot: number;
  grzalka: boolean;
}

export interface AdminTesterTypeReply {
  ok: boolean;
  typ: number;
  nazwa: string;
  grupa: number;
  wersja: number;
  wyjscia: Array<Output>;
  nastawy: unknown;
}

export interface AdminTesterTypeIn {
  nazwa: string;
  grupa: number;
  wyjscia: Array<Output>;
  nastawy: unknown;
  uwagi: string;
}

export interface AdminTesterProfileOut {
  id: number;
  nazwa: string;
  wartosci: Array<Setting>;
  wlasciciel: number;
  tester_sn: string;
  grupa: string;
  kolejnosc: number;
  zmiana: number;
}

export interface AdminTesterProfilesReply {
  ok: boolean;
  profile: Array<AdminTesterProfileOut>;
}

export interface AdminTesterProfileIn {
  id: number;
  nazwa: string;
  wartosci: Array<Setting>;
  wlasciciel: number;
  tester_sn: string;
  grupa: string;
  kolejnosc: number;
}

export interface AdminTesterProfileReply {
  ok: boolean;
  id: number;
}

export interface AdminCalculatorsReply {
  ok: boolean;
  v: number;
  kalkulatory: unknown;
  tablety: number;
}

export interface AdminCalculatorsIn {
  kalkulatory: unknown;
}

export interface AdminLogEntry {
  czas: string;
  strumien: string;
  tekst: string;
}

export interface AdminLogsReply {
  ok: boolean;
  kontenery: Array<string>;
  linie: Array<AdminLogEntry>;
}

export interface AdminSQLIn {
  zapytanie: string;
}

export interface AdminSQLReply {
  ok: boolean;
  kolumny: Array<string>;
  wiersze: Array<Array<string | null>>;
  uciete: boolean;
  blad?: string;
}

export type TypLinii = "piec" | "sterownik-650" | "sterownik-now" | "tablet" | "termometr-t4" | "tester-now" | "wedzarnia-2" | "unknown";
/** Nazwa linii dla klienta (devtype.Type.Name - te same w tytułach powiadomień). */
export const NAZWY_LINII: Record<TypLinii, string> = {
  "piec": "Piec",
  "sterownik-650": "Sterownik",
  "sterownik-now": "Sterownik",
  "tablet": "Tablet",
  "termometr-t4": "Termometr T-4",
  "tester-now": "Tester",
  "wedzarnia-2": "Wędzarnia",
  "unknown": "Inne",
};
/** Linie przyjmujące przepisy (devtype.Type.Recipes) → okno potwierdzenia wysyłki [s] - zakładka Przepisy
 *  i wybór sterownika przy wysyłce. */
export const PRZEPISY_LINII: Partial<Record<TypLinii, number>> = {"wedzarnia-2":10};
/** Linie z pogodą przebiegów (devtype.RunPolicy.Weather) - lokalizacja w Ustawieniach. */
export const POGODA_LINII: TypLinii[] = ["wedzarnia-2"];
/** Linie z osiągnięciami (devtype.RunPolicy.Achievements) → dziedzina - zakładka Osiągnięcia. */
export const OSIAGNIECIA_LINII: Partial<Record<TypLinii, string>> = {"sterownik-650":"destylacja","sterownik-now":"destylacja","wedzarnia-2":"wedzenie"};
/** Linie z energią (devtype.Type.Energy): licznik kWh sterownika albo szacunek z mocy i czasu pracy grzałki
 *  - zakładka Energia. */
export const ENERGIA_LINII: Partial<Record<TypLinii, "licznik" | "szacunek">> = {"sterownik-now":"licznik","wedzarnia-2":"szacunek"};
export type StatusObecnosci = "online" | "bridge" | "local" | "offline" | "unknown";
export type StatusKomendy = "wykonano" | "skorygowano" | "odrzucono" | "brak_potwierdzenia" | "wyslano";
export type StatusPrzebiegu = "open" | "done" | "aborted";
export type Rola = "podglad" | "pelna" | "serwis" | "wlasciciel" | "admin";
export type Poziom = "sterowanie" | "restart" | "niszczaca";
export type WiadomoscSSE = "urzadzenia" | "widok" | "zdarzenie" | "wynik" | "konto" | "przeladuj" | "wyloguj" | "brak_dostepu" | "polecenie";
export type KodBledu = "zla_tresc" | "zly_adres" | "brak_sesji" | "chwilowa_awaria" | "przerwa_techniczna" | "brak_dostepu" | "zla_komenda" | "brak_strumienia" | "zle_dane" | "niezweryfikowane" | "za_duzo_prob" | "rejestracja_wylaczona" | "rejestracja_niedostepna" | "zly_token_google" | "brak_google" | "zle_haslo" | "slabe_haslo" | "zly_kod" | "nie_ma" | "limit" | "zla_taryfa" | "taryfa_uzyta" | "zle_ustawienia" | "zaproszenie" | "serwis" | "urzadzenie" | "rma" | "firmware" | "urzadzenie_offline" | "urzadzenie_zajete";
export type Kategoria = "alarmy_krytyczne" | "ostrzezenia" | "postep" | "udostepnienia" | "serwis" | "konto";
export type Tryb = "glosno" | "cicho" | "wylaczone";
export type Waznosc = "critical" | "warning" | "info";
export type StatusAlarmu = "unread" | "read" | "resolved" | "accepted" | "rejected";
export type StanAlarmow = "unread" | "read" | "closed";
export type OkresAlarmow = "dzis" | "7d" | "30d";
export type RodzajWniosku = "przypisanie" | "przeniesienie";
export type AkcjaEtapu = "zrobione" | "cofnij" | "odloz";
export type IkonaOdznaki = "plomien" | "wedzarnia" | "puchar" | "gwiazda" | "osiagniecia" | "lista" | "klepsydra" | "pogoda" | "termometr" | "klodka" | "kolumna" | "kropla" | "tarcza" | "cel";
export type StanWniosku = "pending" | "approved" | "rejected";
export type WynikProby = "claimed" | "mine" | "other" | "offline" | "unknown" | "ident" | "rate" | "request";
export type FunkcjaAI = "analiza" | "asystent" | "start" | "kurator" | "seo_serp" | "seo_artykul" | "seo_faq" | "seo_spojnosc" | "seo_kontrole" | "rolki_komentarze";
export type RodzajPrzepisow = "library" | "own" | "shared";
export type SortPrzepisow = "created_desc" | "created_asc" | "name_asc" | "name_desc" | "popular" | "shortest";
export type KategoriaSkladnika = "mieso" | "przyprawa" | "oslonka" | "inne" | "surowiec" | "alkohol" | "slodzenie" | "drozdze";
export type DziedzinaPrzepisu = "wedzarnia" | "trunki";
export type JednostkaSkladnika = "g" | "kg" | "ml" | "l" | "szt" | "m";
export type MetodaPeklowania = "sucho" | "mokro" | "eq" | "solanka" | "bez";
export type WariantPeklowania = "standard" | "mniej";
export type IntensywnoscPeklowania = "delikatne" | "standard" | "mocne";
export type MiesoPeklowania = "wieprzowina" | "wolowina" | "drob" | "dziczyzna";
export type KategoriaWyrobu = "szynka" | "kielbasa" | "boczek" | "ryba" | "drob" | "ser" | "wolowina" | "inne";
export type Uprawnienie = "podglad" | "pelna";
export type StanZaproszenia = "oczekuje" | "wygaslo" | "aktywne" | "zakonczone" | "odrzucone" | "odwolane";
export type StanSerwisu = "prosba" | "wygasla" | "aktywny" | "odrzucona" | "zakonczony";
export type KtoZakonczyl = "klient" | "serwis" | "admin" | "czas";
export type StanEkranu = "prosba" | "aktywna" | "odrzucona" | "zakonczona";
export type CzasSerwisu = "godzina" | "dzien" | "stale";
export type StanAIPrzebiegu = "brak" | "czeka" | "gotowa" | "wstrzymana" | "bez_ai";
export type ZakresAdmina = "rma" | "wnioski" | "przypisania" | "konta" | "obce" | "testery";
export type RodzajAI = "zdjecie_wsadu" | "ocena_zaladunku" | "zdjecie_wyrobu" | "analiza";
export type RodzajPrzepisuAdmina = "library" | "own" | "shared" | "ai";
export type RodzajRMA = "urzadzenie" | "aplikacja" | "tablet";
export type StatusRMA = "new" | "in_progress" | "accepted" | "shipped_in" | "received" | "diagnosis" | "quote_pending" | "quote_rejected" | "awaiting_address" | "repair" | "shipped_out" | "closed" | "cancelled";
export type UsterkaRMA = "wifi" | "sensor" | "relay" | "power" | "display" | "mechanical" | "firmware" | "no_fault" | "other";
export type JezykAPP = "pl" | "en" | "de" | "uk" | "cs" | "sk" | "ru" | "fr" | "es" | "it" | "nl";
export type StanGalerii = "" | "oczekuje" | "zatwierdzone" | "odrzucone";
export type UkladParagonu = "pion" | "kwadrat" | "poziom";
export type PoleParagonu = "czas" | "pogoda" | "energia" | "fazy" | "ocena";
export type StanFrazySeo = "nowa" | "temat" | "pokryta" | "doklejona" | "odrzucona";
export type ZrodloFrazySeo = "gsc" | "suggest" | "paa" | "related" | "oferta" | "panel";
export type StanSprawdzeniaSeo = "czeka" | "w_toku" | "oceniane" | "gotowe" | "blad";
export type OkazjaFrazy = "strona2" | "top3" | "ctr" | "popyt";
export type OcenaStrony = "bez_sprzedazy" | "nie_klikaja" | "strona2" | "top3" | "sprzedaje" | "dziala" | "malo_danych";
export type RodzajWykonawcy = "przegladarka" | "lektor" | "render" | "podpis-testera";
export type RodzajGrafiki = "cykl" | "wpis" | "rolka" | "tablet";
export type StanGrafiki = "czeka" | "w_toku" | "gotowe" | "blad";
export type ProgramAgenta = "seo" | "wykonawca" | "control" | "rolki";
export type WagaZdarzenia = "info" | "uwaga" | "blad" | "awaria";
export type RodzajKroku = "mysl" | "tekst" | "narzedzie" | "wynik" | "blad";
export type WynikWywolania = "trwa" | "ok" | "limit" | "odrzucony" | "blad";
export type PlatformaRolki = "youtube" | "tiktok";
export type StanRolki = "przeglad" | "zaakceptowana" | "odrzucona" | "publikacja" | "opublikowana" | "blad";
export type StanPublikacjiRolki = "czeka" | "w_toku" | "ok" | "blad" | "odlozona";
export type StanKomentarzaRolki = "nowy" | "do_wyslania" | "odpowiedziany" | "blad" | "ukryty";
export type StanPodpowiedziRolki = "czeka" | "gotowa" | "brak";
export type TrybTikToka = "bezposrednio" | "szkic";
export type PrywatnoscYouTube = "public" | "unlisted" | "private";
export type ZrodloTematu = "kandydat" | "wedzenia" | "faq" | "stary" | "panel";
export type StanTematu = "czeka" | "pisze" | "obrazy" | "szkic" | "opublikowany" | "usuniety" | "odrzucony" | "blad";
export type StanFaq = "doklejone" | "obecne" | "straznik" | "sierota";
export type ZrodloBleduFaktow = "straznik" | "ai";
export type WagaBleduFaktow = "zdrowie" | "wazny" | "drobny";
export type StanBleduFaktow = "otwarty" | "poprawiony" | "falszywy";
export type RodzajProblemuSeo = "drift" | "schema" | "geo" | "audyt" | "indeksacja";
export type WagaProblemuSeo = "krytyczny" | "wazny" | "drobny";
export type StanProblemuSeo = "otwarty" | "poprawiony" | "falszywy";
export type RodzajKontroliSeo = "drift" | "schema" | "geo" | "audyt";
export type RodzajIndeksacji = "nowy" | "faq";
export type StanIndeksacji = "czeka" | "zaindeksowana" | "niezaindeksowana" | "blad" | "koniec";
export type StanOdslon = "traci" | "martwa" | "rosnie" | "stabilna";
/** RMA (panel admina): statusy do wyboru wg rodzaju zgłoszenia, ich nazwy i nazwy usterek (store/rma). */
export const STATUSY_RMA: Record<RodzajRMA, readonly StatusRMA[]> = {"aplikacja":["new","in_progress","closed","cancelled"],"tablet":["new","in_progress","closed","cancelled"],"urzadzenie":["new","accepted","shipped_in","received","diagnosis","quote_pending","quote_rejected","awaiting_address","repair","shipped_out","closed","cancelled"]};
export const NAZWY_STATUSOW_RMA: Record<StatusRMA, string> = {"accepted":"Przyjęte - wyślij sprzęt","awaiting_address":"Czekamy na adres zwrotny","cancelled":"Anulowane","closed":"Zamknięte","diagnosis":"Diagnoza","in_progress":"W toku","new":"Nowe","quote_pending":"Wycena - czeka na decyzję","quote_rejected":"Wycena odrzucona","received":"Dostarczone do serwisu","repair":"Naprawa w toku","shipped_in":"Nadane przez klienta","shipped_out":"Wysłane do klienta"};
export const NAZWY_USTEREK_RMA: Record<UsterkaRMA, string> = {"display":"Wyświetlacz / enkoder","firmware":"Oprogramowanie","mechanical":"Uszkodzenie mechaniczne","no_fault":"Brak usterki / obsługa","other":"Inne","power":"Zasilanie","relay":"Przekaźnik / SSR","sensor":"Czujnik temperatury","wifi":"Łączność WiFi/MQTT"};
/** Kategorie powiadomień w kolejności wierszy tabeli (SPIS T-2). */
export const KATEGORIE: Kategoria[] = ["alarmy_krytyczne","ostrzezenia","postep","udostepnienia","serwis","konto"];
/** Czasy dostępu serwisu do wyboru przy zgodzie, w kolejności przycisków. */
export const CZASY_SERWISU: CzasSerwisu[] = ["godzina","dzien","stale"];
export const MIN_HASLO = 8;
/** Języki APP w kolejności wyboru: kod i nazwa w tym języku (store/i18n). */
export const JEZYKI: readonly (readonly [JezykAPP, string])[] = [["pl","Polski"],["en","English"],["de","Deutsch"],["uk","Українська"],["cs","Čeština"],["sk","Slovenčina"],["ru","Русский"],["fr","Français"],["es","Español"],["it","Italiano"],["nl","Nederlands"]];
/** Decyzja po zaniku zasilania (komenda bramy, typy z wznawianiem - widok `run.power_loss`). */
export const WZNOWIENIE = { nazwa: "wznowienie", wznow: "wznow", zakoncz: "zakoncz" } as const;
/** Zgoda na moduł sztuki (komenda bramy, wartość {modul, zgoda}; lista: ModulesReply). */
export const MODUL = "modul";
/** Przepis na sterownik (komenda bramy, wartość {przepis: id}; wynik: echo nazwy ze sterownika). */
export const PRZEPIS_NA_STEROWNIK = "przepis";
/** Teksty „Pomocy krok po kroku” (api/czat_sciezki.go): parowanie Bluetooth wg linii, WiFi przez sieć sterownika
 *  i instalacja aplikacji wg platformy - kreator „+ Dodaj urządzenie” i okno instalacji. */
export const PAROWANIE: Partial<Record<TypLinii, string>> = {"sterownik-now":"Zatrzymaj proces i przytrzymaj przycisk na sterowniku przez około 20 sekund, aż usłyszysz dwa krótkie piknięcia - wtedy puść. Parowanie jest włączone na 5 minut. Jedno długie piknięcie oznacza, że proces nadal trwa - zatrzymaj go i spróbuj jeszcze raz.","termometr-t4":"Termometr nie ma przycisków - parowanie włącza się samo na 5 minut po włączeniu zasilania. Najpierw przygotuj telefon (kroki niżej), a dopiero potem wyłącz i włącz termometr.","wedzarnia-2":"Zatrzymaj proces, na sterowniku wejdź w MENU i wybierz PAROWANIE BT. Sterownik przez 5 minut będzie widoczny przez Bluetooth."};
export const SIEC_AP: readonly string[] = ["Wyłącz i włącz sterownik. Gdy nie ma zapisanej sieci (albo nie może jej znaleźć), przez kilka minut (sterownik wędzarni i termometr T-4 około 3, Sterownik NOW około 10) wystawia własną sieć Wi-Fi „termometrWiFi.pl”.","W telefonie lub komputerze połącz się z siecią „termometrWiFi.pl”, hasło: termometr.","Okno konfiguracji powinno otworzyć się samo. Jeśli nie - wpisz w przeglądarce adres 192.168.4.1.","Wybierz swoją domową sieć Wi-Fi z listy, wpisz jej hasło (sieć 2,4 GHz) i naciśnij Save (w termometrze T-4: Zapisz)."];
export const INSTALACJA: Record<"android" | "iphone" | "komputer", HelpNode> = {"android":{"tytul":"Android","kroki":["Otwórz na telefonie adres app.termometrwifi.pl/pobierz/android i pobierz aplikację TermometrWifi.","Otwórz pobrany plik. Telefon zapyta o zgodę na instalację z przeglądarki - zezwól i wybierz Zainstaluj.","Otwórz aplikację TermometrWifi z ekranu telefonu.","Zaloguj się kontem Google albo loginem i hasłem z konta w sklepie termometrwifi.pl."],"uwaga":"Nowe wersje aplikacja pobiera sama - zobaczysz komunikat o aktualizacji."},"iphone":{"tytul":"iPhone / iPad","kroki":["Otwórz adres app.termometrwifi.pl w przeglądarce Safari - inne przeglądarki na iPhonie nie potrafią dodać aplikacji do ekranu.","Naciśnij ikonę Udostępnij (kwadrat ze strzałką w górę) - na dole Safari, na iPadzie w prawym górnym rogu.","Wybierz „Do ekranu początkowego” i potwierdź Dodaj.","Otwórz aplikację ikoną z ekranu i zaloguj się."],"uwaga":"Bez dodania do ekranu początkowego iPhone nie pokaże powiadomień (wymagany iOS 16.4 lub nowszy)."},"komputer":{"tytul":"Komputer","kroki":["Otwórz app.termometrwifi.pl w przeglądarce Chrome albo Edge.","Naciśnij ikonę instalacji w pasku adresu przeglądarki.","Aplikacja otworzy się w osobnym oknie. Zaloguj się tym samym kontem co na telefonie - zobaczysz te same urządzenia."]}};
/** Akcja linii (KOMENDY_<linia>.akcje) - menu ⋮ w Urządzeniach (D-2, akcje.ts). */
export interface OpisAkcji { tresci?: readonly string[]; poziom: Poziom; skutek?: "online" | "parowanie"; czas_s?: number }

/** Treść `dane` zdarzenia SSE wg `rodzaj`. */
export interface DaneZdarzen {
  "alarm.changed": AlarmChanged;
  "run.opened": RunOpened;
  "run.closed": RunClosed;
  "run.suspended": RunSuspended;
  "run.resumed": RunSuspended;
  "cmd.result": CmdResult;
}

/** Treść `dane` zdarzenia konta (SSE `konto`) wg `rodzaj`. */
export interface DaneKonta {
  "pulpity.zmiana": DashboardsChanged;
  "udostepnienia.zmiana": AccountChanged;
  "serwis.zmiana": AccountChanged;
  "urzadzenia.oczekujace": AccountChanged;
  "urzadzenia.zmiana": AccountChanged;
  "plany.zmiana": PlanChanged;
  "rma.zmiana": RMAChanged;
  "admin.zmiana": AdminChanged;
  "przebieg.ai": RunAI;
  "czat.tekst": ChatLive;
}

export type RodzajEkranu = "komputer" | "tablet" | "telefon";
export const KOLUMNY_PULPITU = { komputer: 12, tablet: 6, telefon: 4 } as const;
export type RodzajKarty = "glowna" | "kompakt" | "pogoda" | "energia" | "zaladunek" | "temperatury" | "sterowanie" | "pompa" | "licznik" | "moduly" | "kanal1" | "kanal2" | "kanal3" | "kanal4" | "moc" | "cisnienie" | "skraplacz" | "woda" | "polka10" | "bufor" | "zbiornik" | "plaszcz" | "temp_dnia";
export const LIMITY_PULPITU = { pulpity: 20, karty: 40, nazwa: 40, wysokosc: 120 } as const;
/** Najdłuższa nazwa urządzenia w znakach (devices.MaxName - „Zmień nazwę”). */
export const NAZWA_URZADZENIA_MAX = 40;
